"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9950],{

/***/ 97404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AdBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88939);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92833);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32223);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92591);



function AdBanner(param) {
    var children = param.children, _isUsingNewLayout = param.isUsingNewLayout, isUsingNewLayout = _isUsingNewLayout === void 0 ? false : _isUsingNewLayout;
    return isUsingNewLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variation: "100",
        rowGap: "xl",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                maxWidth: 728,
                children: children
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        py: 4,
        m: "auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            maxWidth: 728,
            children: children
        })
    });
}


/***/ }),

/***/ 31205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomeDesktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/HeroModule/index.js + 11 modules
var HeroModule = __webpack_require__(38305);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/StyledHeading/index.tsx
var StyledHeading = __webpack_require__(29293);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useSEMSearchHeadline.ts
var useSEMSearchHeadline = __webpack_require__(32881);
// EXTERNAL MODULE: ./src/constants/content.ts
var content = __webpack_require__(66410);
// EXTERNAL MODULE: ./src/hooks/useCityNameInFormHeadlineForSEM.ts
var useCityNameInFormHeadlineForSEM = __webpack_require__(40813);
// EXTERNAL MODULE: ./src/hooks/useContentfulSearchFormHeadlines.ts
var useContentfulSearchFormHeadlines = __webpack_require__(98673);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/Form.tsx + 8 modules
var Form = __webpack_require__(49515);
// EXTERNAL MODULE: ./src/components/Flights/SearchForm/Form.tsx + 4 modules
var SearchForm_Form = __webpack_require__(78393);
// EXTERNAL MODULE: ./src/components/Cars/SearchForm/Form.tsx + 5 modules
var Cars_SearchForm_Form = __webpack_require__(93860);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/Form.tsx + 4 modules
var Packages_SearchForm_Form = __webpack_require__(32118);
// EXTERNAL MODULE: ./src/components/Cruises/SearchForm/Form.tsx + 3 modules
var Cruises_SearchForm_Form = __webpack_require__(73345);
// EXTERNAL MODULE: ./src/components/SearchForm/Bumpers.tsx + 1 modules
var Bumpers = __webpack_require__(51197);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/utils.ts
var utils = __webpack_require__(360);
// EXTERNAL MODULE: ./src/components/Cars/SearchForm/utils.ts
var SearchForm_utils = __webpack_require__(60837);
// EXTERNAL MODULE: ./src/components/Flights/SearchForm/utils.ts
var Flights_SearchForm_utils = __webpack_require__(91753);
// EXTERNAL MODULE: ./src/components/Hotels/SearchForm/utils.ts
var Hotels_SearchForm_utils = __webpack_require__(84822);
;// CONCATENATED MODULE: ./src/components/SearchForm/reducer.tsx












function formPicker(values, tab, headline, setLocation, showMultiHotel) {
    switch(tab){
        case "flights":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_Form/* default */.Z, {
                    onSubmit: Flights_SearchForm_utils/* onSubmit */.MI
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* FlightsBumper */.HG, {}),
                headline: values.flights.headline
            };
        case "cars":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cars_SearchForm_Form/* default */.Z, {
                    onSubmit: SearchForm_utils/* handleSubmitForCars */.Rh
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* CarsBumper */.IQ, {}),
                headline: values.cars.headline
            };
        case "vacations":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Packages_SearchForm_Form/* default */.Z, {
                    onSubmit: utils/* onSubmit */.MI,
                    isLandingPage: false
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* VacationBumper */.UB, {}),
                headline: values.vacations.headline
            };
        case "cruises":
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Cruises_SearchForm_Form/* default */.Z, {}),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* CruiseBumper */.d7, {}),
                headline: values.cruises.headline
            };
        default:
            return {
                component: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                    onSubmit: Hotels_SearchForm_utils/* handleSubmitForHotels */.Ky,
                    setLocation: setLocation,
                    showMultiHotel: showMultiHotel
                }),
                bumper: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bumpers/* HotelsBumper */.np, {
                    showMultiHotel: showMultiHotel
                }),
                headline: headline
            };
    }
}
var reducer = function(_state, action) {
    return formPicker(action.values, action.type, action.vipHead, action.setLocation, action.showMultiHotel);
};
/* harmony default export */ var SearchForm_reducer = (reducer);

// EXTERNAL MODULE: ./src/components/SearchForm/constants.ts
var constants = __webpack_require__(67685);
// EXTERNAL MODULE: ./src/context/SearchFormContext.tsx
var SearchFormContext = __webpack_require__(51069);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/utils/utils.js
var utils_utils = __webpack_require__(67113);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./src/components/ProductIcon.tsx
var ProductIcon = __webpack_require__(60189);
;// CONCATENATED MODULE: ./src/components/SearchForm/Tabs.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:hover {\n    text-decoration: none;\n  }\n  z-index: 1;\n  position: relative;\n  border: 2px solid\n    ",
        ";\n  background-color: ",
        ";\n  &:hover ",
        " {\n    border: 1px solid\n      ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  height: 44px;\n  z-index: 0;\n  border: 2px solid\n    ",
        ";\n  background-color: ",
        ";\n  transition: margin-left 0.4s ease-in-out, width 0.4s ease-in-out;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-df8b5252-0"
})(_templateObject());
var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-df8b5252-1"
})(_templateObject1(), function(props) {
    return props.isActive ? "transparent" : (0,utils_utils/* getPaletteColor */.ow)("background.base");
});
var TabWithIcon = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-df8b5252-2"
})(_templateObject2(), function(props) {
    return props.highlightTab ? (0,utils_utils/* getPaletteColor */.ow)("primary.base") : "transparent";
}, function(props) {
    return props.highlightTab ? (0,utils_utils/* getPaletteColor */.ow)("primary.light") : "transparent";
}, IconWrapper, function(props) {
    return props.isActive ? "transparent" : (0,utils_utils/* getPaletteColor */.ow)("primary.base");
});
var Slider = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-df8b5252-3"
})(_templateObject3(), function(props) {
    return props.showSlider ? (0,utils_utils/* getPaletteColor */.ow)("primary.base") : "transparent";
}, function(props) {
    return props.showSlider ? (0,utils_utils/* getPaletteColor */.ow)("primary.light") : "transparent";
});
function Tabs(param) {
    var onClick = param.onClick;
    var router = (0,next_router.useRouter)();
    var query = router.query, pathname = router.pathname;
    var ref = (0,react.useState)(router.query.tab ? router.query.tab : "hotels"), activeTab = ref[0], setActiveTab = ref[1];
    var ref1 = (0,react.useState)(""), hoveredTab = ref1[0], setHoverTab = ref1[1];
    var ref2 = (0,react.useState)(0), sliderWidth = ref2[0], setSliderWidth = ref2[1];
    var ref3 = (0,react.useState)(0), sliderOffset = ref3[0], setSliderOffset = ref3[1];
    var ref4 = (0,react.useState)(false), showSlider = ref4[0], setShowSlider = ref4[1];
    var ref5 = (0,react.useState)(false), highlightTab = ref5[0], setHighlightTab = ref5[1];
    (0,react.useEffect)(function() {
        var currentTab = typeof activeTab === "string" ? activeTab : "hotels";
        var currentTabElement = document.getElementById("tab-".concat(currentTab));
        if (currentTabElement) {
            setSliderOffset(currentTabElement.offsetLeft);
            setSliderWidth(currentTabElement.offsetWidth);
        }
    }, [
        activeTab
    ]);
    var handleOnClick = function(tab) {
        setActiveTab(tab.id);
        router.push({
            pathname: pathname,
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, query), {
                tab: tab.query.tab
            })
        }, undefined, {
            shallow: true
        });
        onClick(tab.id);
        analytics/* default.fireEvent */.Z.fireEvent({
            action: "tab",
            category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
            label: tab.id
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        role: "tablist",
        "aria-label": "Types of travel",
        mx: 3,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Slider, {
                id: "slider",
                my: "auto",
                tabIndex: "-1",
                "aria-hidden": "true",
                ml: sliderOffset,
                width: sliderWidth,
                borderRadius: "full",
                variation: "link",
                showSlider: showSlider,
                onTransitionEnd: function() {
                    setShowSlider(false);
                    setHighlightTab(true);
                }
            }),
            constants/* PRODUCT_TABS.map */.bW.map(function(tab) {
                var isActive = tab.id === activeTab;
                var isHoveredTab = tab.id === hoveredTab;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TabWithIcon, {
                    mr: [
                        0,
                        null,
                        null,
                        3
                    ],
                    width: [
                        1,
                        null,
                        null,
                        "auto"
                    ],
                    color: (0,utils_utils/* getPaletteColor */.ow)("primary.base"),
                    variation: "link",
                    role: "tab",
                    pr: [
                        2,
                        null,
                        null,
                        3
                    ],
                    borderRadius: "full",
                    isActive: isActive,
                    highlightTab: isActive && highlightTab,
                    "aria-selected": isActive,
                    "aria-controls": "panel-".concat(tab.id),
                    "aria-label": "Search for ".concat(tab.id),
                    id: "tab-".concat(tab.id),
                    "data-testid": tab.autobotID,
                    onMouseEnter: function() {
                        return setHoverTab(tab.id);
                    },
                    onMouseLeave: function() {
                        return setHoverTab("");
                    },
                    onClick: function() {
                        handleOnClick(tab);
                        if (!isActive) {
                            setShowSlider(true);
                            setHighlightTab(false);
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                display: [
                                    "none",
                                    null,
                                    "block"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                                    isActive: isActive,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    pt: "2px",
                                    borderRadius: "50%",
                                    width: 40,
                                    height: 40,
                                    bg: "background",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductIcon/* default */.Z, {
                                        name: tab.id,
                                        isActive: isActive || isHoveredTab,
                                        size: "24px"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                ml: 2,
                                mb: "2px",
                                fontSize: 1,
                                fontWeight: isActive ? "bold" : 100,
                                children: tab.tabText
                            })
                        ]
                    })
                }, tab.id);
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/SearchForm/index.tsx

function SearchForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 24px 24px 6px 6px;\n"
    ]);
    SearchForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-66343fa2-0"
})(SearchForm_templateObject());
var getHeadlineWithFirstName = function(template, firstName) {
    return firstName ? template.replace("{firstName}", firstName) : content/* GREETING_DESKTOP */.gL;
};
function SearchForm() {
    var query = (0,next_router.useRouter)().query;
    var currentTab = Object.keys(query).length && typeof query.tab === "string" && query.tab ? query.tab : "hotels";
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), firstName = ref.customer.firstName, _signInStatus = ref.signInStatus, signedIn = _signInStatus.signedIn, passiveSignIn = _signInStatus.passiveSignIn;
    var isSignedIn = signedIn || passiveSignIn;
    var ref1 = (0,react.useState)(), location = ref1[0], setLocation = ref1[1];
    var prePopHeadline = (0,useCityNameInFormHeadlineForSEM/* default */.Z)(location);
    var SEMHeadline = (0,useSEMSearchHeadline/* default */.Z)();
    var VALUES = {
        hotels: (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormHotels", currentTab === "hotels") || constants/* HEADERS.hotels */.ob.hotels,
        flights: (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormFlights", currentTab === "flights") || constants/* HEADERS.flights */.ob.flights,
        vacations: (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormVacations", currentTab === "vacations") || constants/* HEADERS.vacations */.ob.vacations,
        cars: (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormCars", currentTab === "cars") || constants/* HEADERS.cars */.ob.cars,
        cruises: (0,useContentfulSearchFormHeadlines/* default */.Z)("searchFormCruises", currentTab === "cruises") || constants/* HEADERS.cruises */.ob.cruises
    };
    var defaultHeadline = prePopHeadline || SEMHeadline || VALUES.hotels.headline;
    /**
   * TODO: Add these values to contentful and add fallback values as well
   */ var headlineWithName = getHeadlineWithFirstName(content/* default.homepage.vip.headlineWithName */.ZP.homepage.vip.headlineWithName, firstName);
    var hotelHeadline = !isSignedIn ? defaultHeadline : headlineWithName;
    var showMultiHotel = (0,useSeti/* default */.Z)("PKG_FE_HH_HOTEL_HOME_PAGE") === "VARIANT";
    var ref2 = (0,react.useReducer)(SearchForm_reducer, formPicker(VALUES, currentTab, hotelHeadline, setLocation, showMultiHotel)), state = ref2[0], dispatch = ref2[1];
    (0,react.useEffect)(function() {
        dispatch({
            values: VALUES,
            type: currentTab,
            vipHead: hotelHeadline,
            setLocation: setLocation,
            showMultiHotel: showMultiHotel
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentTab,
        hotelHeadline
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                pl: 3,
                pb: [
                    16,
                    null,
                    null,
                    null,
                    4
                ],
                pr: [
                    0,
                    null,
                    null,
                    null,
                    "130px"
                ],
                tag: "h1",
                color: "text.heading",
                text: state.headline,
                mx: [
                    4,
                    null,
                    null,
                    null,
                    0
                ],
                textStyle: [
                    "heading2",
                    "heading3",
                    null,
                    "heading2",
                    null,
                    "heading1"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                boxShadowSize: "xl",
                borderWidth: 0,
                borderRadius: "2xl",
                minWidth: [
                    null,
                    null,
                    null,
                    "720px"
                ],
                color: "background.lightest",
                mx: [
                    4,
                    null,
                    null,
                    null,
                    0
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                        boxShadowSize: "none",
                        borderWidth: 0,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                                p: 3,
                                tag: "h2",
                                color: "text.light",
                                text: "",
                                textStyle: [
                                    "subheading6",
                                    "subheading4"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
                                onClick: function(name) {
                                    dispatch({
                                        values: VALUES,
                                        type: name,
                                        vipHead: hotelHeadline,
                                        setLocation: setLocation,
                                        showMultiHotel: showMultiHotel
                                    });
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchFormContext/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                p: 3,
                                id: "panel-".concat(currentTab),
                                "aria-labelledby": "tab-".concat(currentTab),
                                children: state.component
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: state.bumper
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useContentfulVariation.ts + 1 modules
var useContentfulVariation = __webpack_require__(49356);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Divider/Divider.js
var Divider = __webpack_require__(11477);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/@pcln/vip/dist/esm/appDownload/AppDownload.js + 2 modules
var AppDownload = __webpack_require__(90370);
// EXTERNAL MODULE: ./node_modules/@pcln/contentful-components/lib-esm/useContentful/useContentful.js
var useContentful = __webpack_require__(61388);
// EXTERNAL MODULE: ./src/components/SmsOptIn/index.tsx + 3 modules
var SmsOptIn = __webpack_require__(90924);
// EXTERNAL MODULE: ./src/components/MerchModuleWrapper/PromoBanners.tsx
var PromoBanners = __webpack_require__(8862);
// EXTERNAL MODULE: ./src/components/AdBanner.tsx
var AdBanner = __webpack_require__(97404);
// EXTERNAL MODULE: ./src/components/WhyPricelineBanner/index.ts + 2 modules
var WhyPricelineBanner = __webpack_require__(57969);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/@pcln/content-tile/dist/esm/index.js + 3 modules
var esm = __webpack_require__(60034);
;// CONCATENATED MODULE: ./src/components/PopularDestinations/utils.ts

function generateLinkArray(param) {
    var searchCity = param.searchCity, staySearchHref = param.staySearchHref, flySearchHref = param.flySearchHref, driveSearchHref = param.driveSearchHref;
    return [
        {
            gaAction: "Popular_Hotels_Destinations",
            gaCategory: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
            gaLabel: "Hotels Link | ".concat(searchCity),
            href: "".concat(staySearchHref),
            linkTitle: "Hotels",
            target: "_blank"
        },
        {
            gaAction: "Popular_Cars_Destinations",
            gaCategory: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
            gaLabel: "Cars Link | ".concat(searchCity),
            href: "".concat(driveSearchHref),
            linkTitle: "Cars",
            target: "_blank"
        },
        {
            gaAction: "Popular_Flights_Destinations",
            gaCategory: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
            gaLabel: "Flights Link | ".concat(searchCity),
            href: "".concat(flySearchHref),
            linkTitle: "Flights",
            target: "_blank"
        }
    ];
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/PopularDestinationTile.tsx





var PopularDestinationTile = function(param) {
    var destination = param.destination;
    var searchCity = destination.searchCity, image = destination.image, imageWebP = destination.imageWebP, staySearchHref = destination.staySearchHref, svg = destination.svg, title = destination.title, width = destination.width, flySearchHref = destination.flySearchHref, driveSearchHref = destination.driveSearchHref;
    var productLinks = generateLinkArray({
        searchCity: searchCity,
        staySearchHref: staySearchHref,
        flySearchHref: flySearchHref,
        driveSearchHref: driveSearchHref
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        p: 2,
        width: width,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ImageTile */.a5, {
            height: "301px",
            image: image,
            imageWebP: imageWebP,
            navArray: productLinks,
            title: title,
            borderRadius: "xl",
            useLink: true,
            children: svg()
        })
    });
};
/* harmony default export */ var PopularDestinations_PopularDestinationTile = (PopularDestinationTile);

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/Atlanta.tsx


function Atlanta() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "174",
        height: "36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "atl-path",
                        d: "M135.882 157.392l-1.647-8.17-1.732 8.17h3.379zm-4.393-17.99c.127-1.185 1.056-2.37 2.366-2.37 4.181 0 8.067 2.243 9.123 4.487.633 1.354 6.546 19.724 7.053 20.867.296.89 1.183 1.863 1.183 2.794 0 .889-1.943 1.397-6.42 1.397-3.421 0-5.11-.127-5.871-.254-.76-.127-1.014-.339-1.014-.804 0-.254.127-.635.127-.932 0-.254-.042-.592-.084-.762l-.718-2.285h-6.082l-.592 1.82c-.169.465-.253.846-.253 1.27 0 .338.084.889.084 1.1 0 .296-.422.635-.802.677-.38.043-1.183.17-2.746.17-1.985 0-2.703-.043-3.21-.127-.337-.043-.633-.17-.633-.466 0-.338.296-.592.591-1.27.338-.846 6.927-20.74 7.138-21.545.38-1.439.634-2.666.76-3.767zm35.056 7.83l2.872.847c1.732 0 3.633-3.09 3.633-5.63h-6.505c0-2.116.55-3.766.55-4.528 0-1.059-3.253-2.921-6.42-2.921-2.239 0-5.829 1.228-5.829 2.92 0 .805.591 3.26.591 4.91l-2.196-.677c-1.69 0-1.943 4.149-1.943 5.376h3.295c.506 0 .844.635.844 1.524v10.751c0 3.81 1.479 7.196 7.18 7.196 5.491 0 10.137-2.201 10.137-4.995 0-.508-.253-1.481-.634-1.65-.929.888-3.125 1.566-4.18 1.566-.803 0-1.395-.55-1.395-1.567v-13.121zm8.448 11.345c0 2.412-.465 5.968-.465 6.688 0 .507.253.761.633.888.719.212 2.873.424 5.66.424 2.703 0 4.224-.17 5.364-.424.465-.084.591-.465.591-.973 0-.889-.675-3.598-.675-6.307v-10.497c0-4.699.76-8.381 1.478-10.667-1.52-1.228-5.87-2.243-7.645-2.243-3.548 0-6.166 1.566-6.166 3.259.591.423 1.225 2.794 1.225 5.503v14.349zm26.988-16.974c6.42 0 11.404 2.582 11.404 9.185v8.974c0 1.778.634 3.217 1.014 3.344.21.127.338.423.338.72 0 2.2-3.76 3.174-5.28 3.174-3.379 0-4.688-1.016-5.702-2.709-1.098 1.735-4.35 2.709-7.813 2.709-4.224 0-7.603-1.566-7.603-5.08 0-3.428 2.534-5.206 5.195-6.095 2.492-.846 5.237-1.481 8.743-1.481 0-6.01-.971-8.762-2.112-8.762-1.056 0-1.563 1.016-1.563 3.005 0 1.482.38 2.92.76 3.556-.97.973-3.547 1.778-5.87 1.778-2.28 0-4.097-1.524-4.097-4.572 0-4.91 6.082-7.746 12.586-7.746zm-2.914 18.498c0 1.862.634 2.878 1.436 2.878.676 0 1.52-1.058 1.774-2.032V156.8c-1.647 0-3.21 1.735-3.21 3.302zm28.51-14.815c-.972-1.82-2.957-2.836-5.534-2.836-2.618 0-5.828 1.862-5.828 3.428.676.635 1.394 1.736 1.394 3.514v12.232c0 1.863-.338 2.879-.338 3.556 0 .55.338.804.887.973 1.225.34 3.379.424 4.857.424 2.07 0 4.139-.085 5.28-.466.253-.085.802-.55.802-1.016 0-.846-.38-3.047-.38-5.63v-10.54c.338-.253.676-.38 1.098-.38 1.351 0 2.027 1.481 2.027 3.302v10.285c0 .72-.169 2.455-.169 3.175 0 .508.296.72.592.804.76.212 2.66.466 5.026.466 2.28 0 4.35-.085 5.533-.508.337-.127.549-.55.549-1.1 0-.72-.423-1.779-.423-5.207v-10.963c0-3.852-3.252-7.196-7.771-7.196-3.379 0-6.251 1.482-7.603 3.683zm32.183 1.947l2.872.846c1.732 0 3.633-3.09 3.633-5.63h-6.505c0-2.116.55-3.766.55-4.528 0-1.059-3.253-2.921-6.42-2.921-2.24 0-5.83 1.228-5.83 2.92 0 .805.592 3.26.592 4.91l-2.196-.677c-1.69 0-1.943 4.149-1.943 5.376h3.294c.507 0 .845.635.845 1.524v10.751c0 3.81 1.478 7.196 7.18 7.196 5.491 0 10.137-2.201 10.137-4.995 0-.508-.253-1.481-.634-1.65-.929.888-3.125 1.566-4.181 1.566-.802 0-1.394-.55-1.394-1.567v-13.121zm20.485-5.63c6.42 0 11.403 2.582 11.403 9.185v8.974c0 1.778.634 3.217 1.014 3.344.211.127.338.423.338.72 0 2.2-3.759 3.174-5.28 3.174-3.378 0-4.688-1.016-5.701-2.709-1.099 1.735-4.35 2.709-7.814 2.709-4.224 0-7.603-1.566-7.603-5.08 0-3.428 2.535-5.206 5.196-6.095 2.491-.846 5.237-1.481 8.742-1.481 0-6.01-.971-8.762-2.111-8.762-1.056 0-1.563 1.016-1.563 3.005 0 1.482.38 2.92.76 3.556-.971.973-3.548 1.778-5.87 1.778-2.281 0-4.098-1.524-4.098-4.572 0-4.91 6.082-7.746 12.587-7.746zm-2.915 18.498c0 1.862.634 2.878 1.436 2.878.676 0 1.521-1.058 1.774-2.032V156.8c-1.647 0-3.21 1.735-3.21 3.302z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "atl-filter",
                        width: "104.7%",
                        height: "125%",
                        x: "-2.4%",
                        y: "-6.2%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-121 -135)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#000",
                        filter: "url(#atl-filter)",
                        xlinkHref: "#atl-path"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#FFF",
                        xlinkHref: "#atl-path"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/Dallas.tsx


function Dallas() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "174",
        height: "36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "dal-path",
                        d: "M42 67.627V36.373h13.144c1.576 0 13.849.455 13.849 15.896 0 13.62-11.237 15.358-15.176 15.358H42zm1.659-29.64l.041 27.985h10.117c3.524 0 13.517-1.574 13.517-13.703 0-13.868-10.78-14.282-12.19-14.282H43.659zm6.468 6.044v15.607h3.151c1.99 0 7.505-.911 7.546-7.7 0-4.181-2.28-7.907-6.841-7.907h-3.856zm-1.659 17.304v-18.96h5.515c5.639 0 8.5 4.471 8.5 9.563-.042 8.28-6.8 9.397-9.205 9.397h-4.81zm36.861-19.54h2.28L93 56.824H79.815l5.514-15.027zm1.161 1.946l-4.312 11.426h8.5c-1.493-4.264-2.612-6.872-4.188-11.426zm-3.814-5.713l-10.2 27.944h4.229a202.74 202.74 0 0 0 1.534-4.72h16.42l1.824 4.72h4.768c-3.524-9.356-7.049-18.546-10.573-27.944h-8.002zm-12.688 29.6l11.527-31.255h10.324l11.776 31.254h-8.252l-1.783-4.719H79.4c-.498 1.45-1.202 3.395-1.617 4.72h-7.795zm35.078 0V36.372h8.044v23.513h13.268v7.741h-21.312zm1.658-29.6V65.93h17.996v-4.388h-13.27V38.028h-4.727zm21.313 29.6V36.372h8.043v23.513h13.269v7.741h-21.312zm1.658-29.6V65.93h17.995v-4.388h-13.268V38.028h-4.727zm35.576 3.768h2.28l5.39 15.027h-13.185l5.515-15.027zm1.16 1.945l-4.311 11.426h8.5c-1.493-4.264-2.613-6.872-4.188-11.426zm-3.814-5.713l-10.2 27.944h4.23c.497-1.45 1.119-3.395 1.533-4.72h16.42l1.824 4.72h4.769c-3.525-9.356-7.05-18.546-10.573-27.944h-8.003zm-12.688 29.6l11.527-31.255h10.324l11.776 31.254h-8.251l-1.783-4.719h-14.18c-.498 1.45-1.203 3.395-1.618 4.72h-7.795zm47.31.372c-4.188 0-12.024-1.78-12.024-5.837 0-.994 2.529-4.926 2.529-4.926 2.032 1.78 6.054 3.477 9.163 3.477 2.82 0 5.059-.952 5.183-2.318 0-1.242-3.027-2.194-6.136-3.105l-.54-.166c-2.404-.745-4.975-1.531-6.592-2.732-2.363-1.697-3.773-4.057-3.773-6.665 0-5.464 6.51-9.728 14.429-9.728 4.685 0 12.315 1.49 12.315 5.382 0 2.4-2.695 5.05-2.695 5.05-2.488-2.898-6.22-3.229-9.08-3.229-3.608 0-5.018 1.118-5.018 2.153 0 1.283 4.105 2.856 7.38 4.098 1.493.538 3.359 1.242 4.23 1.739 3.69 2.07 5.39 4.388 5.39 7.368 0 5.134-7.049 9.439-14.761 9.439zm0-1.656c6.883 0 13.102-3.56 13.102-7.783 0-2.36-1.243-4.098-4.56-5.878-.954-.497-2.281-1.035-3.732-1.573l-.249-.083c-3.898-1.449-8.459-3.063-8.459-5.671 0-1.863 1.908-3.809 6.676-3.809 2.903 0 6.427.911 8.749 2.608.456-.58 1.244-1.656 1.244-2.69 0-.125-.042-.208-.042-.332-.539-2.65-5.763-3.643-10.531-3.643-7.008 0-12.73 3.685-12.73 8.238 0 1.987 1.244 3.933 3.11 5.34 1.576.994 4.354 1.946 6.634 2.65 3.773 1.118 7.298 2.153 7.298 4.72-.125 2.276-3.069 3.932-6.842 3.932-3.068 0-6.468-1.532-8.5-2.98-.622.827-1.534 2.483-1.534 2.773 0 2.898 6.759 4.181 10.366 4.181z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "dal-filter",
                        width: "104.7%",
                        height: "125%",
                        x: "-2.4%",
                        y: "-6.2%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-40 -36)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#000",
                        filter: "url(#dal-filter)",
                        xlinkHref: "#dal-path"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#FFF",
                        xlinkHref: "#dal-path"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/Denver.tsx


function Denver() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "153",
        height: "36",
        viewBox: "0 0 153 36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "den-path",
                        d: "M68.02 67.45H53.045l.23-2.193 3.708-.777V39.886c0-.55-.275-.777-.916-.915L53 38.24l.32-2.24h14.882c11.22 0 15.89 6.4 15.89 14.766 0 9.188-6.594 16.685-16.073 16.685zm-3.71-2.97l3.572.64c5.586-1.143 9.203-6.4 9.203-12.89 0-6.95-2.884-13.213-9.57-13.213H63.44V63.61c0 .55.23.733.87.87zm40.753-2.15l.916 1.42c-3.39 2.604-6.045 4.25-9.434 4.25-6.227 0-10.028-4.57-10.028-11.11 0-7.22 6.594-12.16 12.134-12.16 4.488 0 7.418 3.293 7.418 8.64 0 .55 0 1.1-.09 1.647H92.516c0 4.663 1.877 9.554 6.73 9.554 1.33 0 3.206-.776 5.816-2.24zm-4.35-9.78v-.87c0-2.97-1.603-4.663-3.938-4.663-.687 0-1.374.137-2.106.412-1.01 1.233-1.74 3.2-2.016 5.484l8.06-.365zm33.7 14.9l.276-2.1-2.657-.64c-.595-.14-.824-.413-.824-.87V51.177c0-4.754-3.07-6.446-6.503-6.446-.595 0-1.1.047-1.65.14l-5.86 3.016V44.73c-3.113.366-6.227.64-9.34 1.006l.09 2.057 3.435.732v16.137l-3.205.686-.275 2.102h11.95l.276-2.102-2.106-.64c-.458-.138-.825-.412-.825-.87V49.807l4.26-1.83c.55-.227 1.006-.32 1.464-.32 1.512 0 2.474 1.51 2.474 3.338v13.67l-2.565.685-.275 2.1h11.86zm14.883 0l8.105-19.427 2.153-.55.275-2.193h-8.655l-.412 2.15 2.61.593c.32.09.46.274.46.594 0 .183-.092.55-.23.914l-4.35 10.927-5.357-12.434 3.022-.594.275-2.15h-11.677l-.412 2.194 1.97.595c.458.136.733.41.96.867L146.963 68l2.335-.55zm30.36-5.12l.914 1.42c-3.388 2.604-6.044 4.25-9.432 4.25-6.228 0-10.028-4.57-10.028-11.11 0-7.22 6.593-12.16 12.134-12.16 4.487 0 7.418 3.293 7.418 8.64 0 .55 0 1.1-.092 1.647h-13.462c0 4.663 1.878 9.554 6.73 9.554 1.33 0 3.207-.776 5.817-2.24zm-4.35-9.78v-.87c0-2.97-1.604-4.663-3.94-4.663-.686 0-1.373.137-2.106.412-1.007 1.233-1.74 3.2-2.014 5.484l8.06-.365zm20.467 14.9l.274-2.1-3.434-.64c-.595-.14-.824-.367-.824-.87V49.85l3.57-1.6c.733.32 1.42.916 1.42 2.15v1.234h1.832c1.877 0 3.388-1.188 3.388-3.29 0-2.56-2.29-3.613-4.35-3.613-.412 0-.87.047-1.282.184l-4.58 3.017v-3.2l-9.386 1.007.137 2.057 3.434.732v16.137l-3.252.686-.228 2.1h13.28z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "den-filter",
                        width: "105.4%",
                        height: "125%",
                        x: "-2.7%",
                        y: "-6.2%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-51 -36)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#000",
                        filter: "url(#den-filter)",
                        xlinkHref: "#den-path"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#FFF",
                        xlinkHref: "#den-path"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/LosAngeles.tsx


function LosAngeles() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "la-svg-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "295",
            height: "38",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "la-path",
                            d: "M0 67V37h7.353v23.7h13.054V67H0zm1.85-1.4l3.652-3.5V38.4H1.85v27.2zM21.759 52c0-8.95 6.652-16 16.155-16 9.453 0 16.156 7.05 16.156 16s-6.703 16-16.156 16c-9.503 0-16.155-7.05-16.155-16zm7.452 0c0 5.05 3.351 9.05 8.703 9.05 5.302 0 8.703-4 8.703-9.05 0-5.05-3.401-9.05-8.703-9.05-5.352 0-8.703 4-8.703 9.05zm-5.302 3.15c1.3 6.6 6.753 11.35 14.005 11.35 7.203 0 12.654-4.8 14.005-11.35h-3.851c-1.2 4.35-4.902 7.45-10.154 7.45s-8.953-3.15-10.153-7.45h-3.852zM59.02 58.2h7.153c0 1.75 1.4 3.15 3.101 3.15 1.85 0 3.001-1.05 3.001-2.6 0-2.25-2.951-2.9-5.402-3.75-5.052-1.8-7.853-4.15-7.853-9.3 0-5.3 4.552-9.7 10.204-9.7 6.652 0 9.803 4.25 10.203 9.8h-6.902c0-1.7-1.05-3.1-3.101-3.1-1.6 0-3.151.95-3.151 2.9 0 2.25 2.75 2.65 5.302 3.4 5.352 1.6 7.852 4.6 7.852 9.3 0 5.3-4.501 9.7-10.153 9.7-6.552 0-10.254-4.4-10.254-9.8zm14.856-13.8h3.75c-.3-2.95-2.5-7-8.352-7v3.9c3.101 0 4.151 1.85 4.602 3.1zM60.77 59.6c.1 3.75 3.751 7 8.503 7v-3.85c-2.55-.05-4.151-1.5-4.602-3.15H60.77zM94.533 67l14.605-31h1.3l14.705 31h-7.902l-1.501-3.1h-11.854l-1.45 3.1h-7.903zm11.654-8.35h7.052l-3.451-7.6h-.1l-3.501 7.6zm9.053 0l3.201 6.95h4.151l-3.3-6.95h-4.052zM97.034 65.6h4.101l3.251-6.95h-4.051l-3.301 6.95zm31.31 1.4V37h7.753l11.654 17.8V37h7.303v30H147.4l-11.704-17.85V67h-7.353zm21.258-10.35l3.601 5.6V38.4h-3.601v18.25zm-19.407 8.95h3.651V47.3l-3.65-5.75V65.6zm29.51-13.6c0-8.95 6.753-16 16.256-16 5.552 0 9.403 2.05 12.554 5.25l-5.102 4.7c-2.05-1.85-4.601-3-7.452-3-5.352 0-8.803 4-8.803 9.05 0 5.55 3.951 9.05 8.953 9.05 5.252 0 7.803-2.9 8.003-5.8h-8.553V48.9h16.505v2.85c0 8.85-5.201 16.25-16.105 16.25-9.503 0-16.256-7.05-16.256-16zm2.151-3.1h3.851c1.2-4.3 5.002-7.35 10.254-7.35 2.65 0 5.252.95 7.352 2.4l2.901-2.8c-2.6-2.45-5.952-3.75-10.253-3.75-7.303 0-12.805 4.85-14.105 11.5zM196.868 67V37h19.857v6.5h-12.504v5.4h11.554v6.4H204.22v5.4h13.054V67h-20.407zm1.85-1.4l3.652-3.5v-20l-3.651-3.7v27.2zm22.108 1.4V37h7.353v23.7h13.054V67h-20.407zm1.851-1.4l3.651-3.5V38.4h-3.65v27.2zm22.108 1.4V37h19.857v6.5h-12.505v5.4h11.554v6.4h-11.554v5.4h13.055V67h-20.407zm1.85-1.4l3.652-3.5v-20l-3.652-3.7v27.2zm21.958-7.4h7.152c0 1.75 1.4 3.15 3.101 3.15 1.851 0 3.002-1.05 3.002-2.6 0-2.25-2.951-2.9-5.402-3.75-5.052-1.8-7.853-4.15-7.853-9.3 0-5.3 4.552-9.7 10.203-9.7 6.653 0 9.804 4.25 10.204 9.8h-6.902c0-1.7-1.05-3.1-3.101-3.1-1.601 0-3.152.95-3.152 2.9 0 2.25 2.751 2.65 5.302 3.4C286.5 50.6 289 53.6 289 58.3c0 5.3-4.502 9.7-10.154 9.7-6.552 0-10.253-4.4-10.253-9.8zm14.855-13.8h3.751c-.3-2.95-2.5-7-8.353-7v3.9c3.102 0 4.152 1.85 4.602 3.1zm-13.104 15.2c.1 3.75 3.75 7 8.502 7v-3.85c-2.55-.05-4.151-1.5-4.601-3.15h-3.901z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "la-filter",
                            width: "104.2%",
                            height: "137.5%",
                            x: "-2.1%",
                            y: "-9.4%",
                            filterUnits: "objectBoundingBox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                    dy: "3",
                                    in: "SourceAlpha",
                                    result: "shadowOffsetOuter1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    in: "shadowOffsetOuter1",
                                    result: "shadowBlurOuter1",
                                    stdDeviation: "1.5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "shadowBlurOuter1",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    transform: "translate(3 -36)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            fill: "#000",
                            filter: "url(#la-filter)",
                            xlinkHref: "#la-path"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            fill: "#FFF",
                            xlinkHref: "#la-path"
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/Miami.tsx


function Miami() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "164",
        height: "46",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "mia-path",
                        d: "M82.714 39.683l-13.4 21.104-7.224-21.104H50.533l-1.793 8.611h2.242L46 79.403h10.063l2.939-19.512 6.974 19.462 13.55-18.864-2.89 18.914h11.558l1.893-8.81h-2.292l4.932-30.96-10.013.05zm28.544 1.643a5.334 5.334 0 0 0-5.33-5.326c-2.94 0-5.33 2.39-5.33 5.326a5.334 5.334 0 0 0 5.33 5.326c2.94 0 5.33-2.39 5.33-5.326zm-11.955 6.869l-1.595 8.91H100l-3.786 22.298h11.756l1.595-8.86h-2.74l3.786-22.348H99.303zm42.84 22.597h1.595l-2.042 8.61h-6.028c-2.341 0-3.836-.497-4.733-1.393-2.142 1.294-5.03 1.991-7.82 1.991-2.84 0-5.58-.747-7.323-2.489-1.943-1.94-2.94-4.878-2.94-8.113 0-4.131 1.644-8.86 5.231-13.04 5.878-6.87 13.6-8.114 13.6-8.114l1.544 3.783.548-3.783h9.415l-3.338 20.607c-.149 1.194.947 1.94 2.292 1.94zm-11.158-5.077l1.545-9.01c-1.893.648-5.33 2.738-7.772 5.725-1.992 2.439-3.038 4.977-3.038 6.77 0 .945.249 1.642.846 2.09.449.348 1.047.497 1.744.497 2.44 0 6.028-2.09 6.675-6.072zm57.786-6.57c.15-.896.25-1.742.25-2.489 0-6.122-4.733-8.76-8.32-8.86-3.587-.05-6.625 1.294-8.32 3.684-1.992-2.489-4.732-3.534-6.874-3.534-2.44 0-3.786.597-4.583 1.095l.1-.797h-11.06l-1.394 8.86h1.744l-3.587 22.299h9.565l3.138-19.412c.697-4.23 2.092-4.878 3.238-4.878 1.046 0 2.341.349 2.341 2.887 0 .548-.05 1.195-.199 1.991l-3.138 19.412h9.016l3.288-19.412c.747-4.43 2.092-4.928 3.288-4.928 1.046 0 2.341.399 2.341 2.937 0 .548-.05 1.195-.2 1.991l-3.486 19.412h11.308l1.345-6.969h-2.242l2.441-13.29zM208 41.325A5.334 5.334 0 0 0 202.67 36c-2.94 0-5.33 2.39-5.33 5.326a5.334 5.334 0 0 0 5.33 5.326c2.939 0 5.33-2.39 5.33-5.326zm-11.956 6.87l-1.594 8.91h2.292l-3.786 22.298h11.756l1.594-8.86h-2.74l3.786-22.348h-11.308z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "mia-filter",
                        width: "102.5%",
                        height: "109.1%",
                        x: "-1.2%",
                        y: "-2.3%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "1",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: ".5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-45 -36)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#000",
                        filter: "url(#mia-filter)",
                        xlinkHref: "#mia-path"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#FFF",
                        xlinkHref: "#mia-path"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/NewYork.tsx


function NewYork() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "175",
        height: "50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "ny-path",
                        d: "M85.04 62.68a9.126 9.126 0 0 1-.418-2.813c0-6.921 3.768-9.816 6.532-9.816 2.387 0 4.816 1.762 4.816 5.58 0 3.564-2.345 5.242-5.235 5.242-.92 0-1.675-.126-2.26-.251.46 3.313 2.47 4.613 4.228 4.613 2.839 0 4.48-2.104 5.232-3.43a15.1 15.1 0 0 1-.081-1.603c0-7.382 2.093-8.976 4.187-8.976.335 0 .963.168.963.503 0 .546-1.382 2.643-1.382 9.48 0 4.488 1.257 4.865 2.052 4.865 1.55 0 2.722-3.607 2.722-5.41 0-7.383 1.884-8.6 3.81-8.6.335 0 1.131.043 1.131.63 0 .545-.963 1.678-.963 8.515 0 4.53 1.34 5.662 2.135 5.662 1.675 0 3.14-4.362 3.14-9.563 0-2.936-.585-4.153-.585-5.075 0-1.217 2.219-2.35 2.93-2.35.755 0 1.383 1.678 1.383 4.321 0 8.389-2.848 14.47-7.119 14.47-2.135 0-3.768-1.383-4.648-4.907-.712 1.93-2.177 4.363-4.438 4.363-1.615 0-3.98-1.117-4.916-4.575-1.135 1.84-3.17 4.155-6.223 4.155-2.442 0-5.023-1.205-6.402-3.67-1.399 2.828-3.974 6.858-7.29 6.858-3.14 0-5.862-2.055-5.862-6.124 0-6.963 4.145-17.784 4.145-23.237 0-1.426-.46-2.181-1.507-2.181-4.816 0-10.636 13.296-11.474 21.433-.335 3.356-.418 5.453-.418 6.837 0 1.133.042 1.762.042 2.265 0 .965-1.424 1.804-2.094 1.804-.838 0-1.633-.336-1.633-3.398 0-2.894.167-6.04.167-9.94 0-2.14-.041-4.53-.209-7.215-.502-7.928-1.256-13.506-5.611-13.506-2.429 0-7.118 3.817-7.118 12.5 0 5.242 2.093 8.682 4.313 8.682 2.051 0 2.596-3.104 2.596-5.327 0-3.65-.796-5.285-1.257-6.082-.125-.21-.209-.378-.209-.545 0-.294.21-.546.503-.546.167 0 .376.084.67.252 1.256.755 3.6 3.146 3.6 6.543 0 3.356-2.26 7.173-6.155 7.173-4.229 0-7.83-3.607-7.83-9.899C43 40.656 49.574 36 54.013 36c6.7 0 8.374 4.95 9.17 17.071 0 0 4.983-15.98 12.73-15.98 2.763 0 4.731 1.803 4.731 4.949 0 5.998-3.601 17.113-3.601 23.321 0 1.93.795 3.356 2.052 3.356 2.617 0 4.809-3.679 5.946-6.038zm80.104-.68a9.88 9.88 0 0 1-.084-1.295c0-2.6.712-4.446 1.717-5.662.21-3.23 3.015-5.747 5.988-5.747 2.596 0 5.946 2.433 5.946 8.6 0 .712-.042 1.383-.126 2.012 2.094-1.468 3.183-4.278 3.936-7.717-.963-.84-2.47-2.14-2.47-4.195 0-1.216 1.13-2.013 1.968-2.013 1.55 0 2.345.755 2.345 5.117.753.671 1.758 1.049 3.224 1.049 1.089 0 1.591.335 1.591 1.006 0 1.007-1.298 3.65-1.298 8.767 0 3.313 1.214 4.068 1.926 4.068 1.847 0 3.418-3.139 4.034-4.559-.238-1.724-.39-3.879-.39-6.556 0-11.954 2.051-16.778 4.773-16.778 1.549 0 2.763 1.3 2.763 4.027 0 6.376-3.14 15.478-4.187 18.414.126 3.104.335 3.355.335 3.355s2.429-13.338 7.998-13.338c1.842 0 3.266 1.3 3.266 3.313 0 4.07-4.732 7.928-4.732 7.928 2.345 2.475 1.885 3.817 3.434 3.817 2.135 0 3.852-4.866 3.852-4.866s.168-.461.545-.461c.293 0 .502.168.502.461 0 .21-.126.588-.126.588s-2.47 7.088-5.862 7.088c-4.145 0-2.847-4.194-5.067-5.788-.209-.126-.293-.42-.293-.671 0-.336.168-.713.293-.755 2.387-.84 3.727-3.733 3.77-7.215 0-.797-.294-.964-.587-.964-2.848 0-5.82 11.744-5.82 13.086 0 .84-1.131 1.678-1.843 1.678-.452 0-1.545-1.015-2.284-4.418-1.029 2.094-2.954 5.047-5.63 5.047-2.429 0-4.439-1.761-4.439-4.907 0-4.446 1.424-7.466 1.424-9.186 0-.378-.544-.965-1.633-1.51-.963 4.236-2.596 7.508-5.61 8.892-1.006 4.404-3.77 6.585-6.533 6.585-2.918 0-5.296-1.82-6.25-4.688-.87 1.342-2.007 2.415-3.255 3.304-.46 6.334-3.56 13.087-10.427 13.087-2.47 0-4.857-1.51-4.857-3.943 0-4.781 6.281-6.04 11.683-8.598.083-.755.125-1.469.125-2.182 0-2.432-.084-7.004-.084-7.088-1.423 3.355-5.443 9.27-10.426 9.27-3.015 0-5.443-2.307-5.443-5.16 0-5.83 3.936-11.493 3.936-17.742 0-4.656-2.22-6.921-4.816-6.921-3.35 0-9.086 3.691-9.086 11.912 0 4.572 1.59 6.753 4.061 6.753 2.178 0 2.848-3.104 2.848-5.327 0-3.649-.796-5.285-1.256-6.082-.126-.21-.21-.377-.21-.545 0-.21.21-.545.503-.545.167 0 .377.084.67.251 1.256.713 3.6 3.146 3.6 6.544 0 3.355-2.386 7.172-6.406 7.172-3.726 0-7.579-2.474-7.579-8.053 0-9.396 7.956-13.716 12.646-13.716 5.276 0 8.919 3.146 8.919 8.892 0 7.34-3.476 11.325-3.476 16.988 0 2.181 1.131 3.104 2.513 3.104 2.889 0 6.783-5.117 7.956-8.767 1.256-3.859 1.633-13.758 1.633-15.351 0-1.3 2.428-2.769 3.308-2.769.628 0 1.13.21 1.13.755 0 .587-1.59 9.102-1.59 16.359 0 4.697.167 7.382.167 10.066 1.16-.904 2.148-1.959 2.847-3.277zM91.28 51.855c.502 0 1.34.88 1.34 3.188 0 2.517-1.047 4.194-2.638 4.194-.67 0-1.173-.042-1.592-.125 0-5.16 1.843-7.257 2.89-7.257zm60.465 25.586c3.768 0 5.904-3.984 6.7-8.389-4.481 2.098-8.92 3.314-8.92 6.754 0 .755.628 1.635 2.22 1.635zM174.9 60.957h.335c.126-.839.21-1.762.21-2.81 0-4.656-1.717-6.627-3.392-6.627-1.214 0-2.303.713-2.931 1.761 1.005-.461 1.968-.629 2.68-.629.754 0 1.088.336 1.088.63 0 .503-.418.545-.711.545-1.173 0-2.513 1.3-2.973 4.278 1.005 1.845 3.056 2.852 5.694 2.852zm-2.93 5.453c1.088 0 2.344-1.258 3.014-3.985h-.21c-2.344 0-4.312-.67-5.736-1.887v.042c0 3.607.963 5.83 2.931 5.83zm24.746-12.248v2.726c1.089-4.026 2.68-10.653 2.68-15.184 0-1.132-.293-1.677-.795-1.677-.754 0-1.885 3.23-1.885 14.135z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "ny-filter",
                        width: "107.1%",
                        height: "127.3%",
                        x: "-3.6%",
                        y: "-6.8%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "3",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: "1.5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-40 -36)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#000",
                        filter: "url(#ny-filter)",
                        xlinkHref: "#ny-path"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#FFF",
                        xlinkHref: "#ny-path"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/Orlando.tsx


function Orlando() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "195",
        height: "36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "orl-path",
                        d: "M57.926 44.695c0 1.645-.391 3.408-1.253 5.288l1.214 1.527c-3.055 7.129-8.381 12.025-15.626 12.025C35.603 63.535 32 58.639 32 53.077c0-8.852 7.089-16.881 16.174-16.881 6.11 0 9.752 3.564 9.752 8.5zm49.599 15.725l-.723 2.449c-1.331-.04-2.82-.078-4.386-.078-4.202 0-8.952.202-13.036.556.58.428 1.167.831 1.757 1.206L83.774 68c-5.6-4.073-10.417-10.967-13.12-17.704l9.165-7.01V41.64c-1.88.157-4.66.51-6.737.94-3.093 6.228-5.287 12.651-6.227 19.545-2.154.627-5.052 1.097-7.558 1.45v-.353c0-4.975 2.467-12.26 6.031-19.506l-3.407-4.543c7.284-1.92 14.412-2.781 21.109-2.781 1.331 0 2.663.039 3.995.117.117.666.156 1.371.156 2.154 0 2.076-.313 4.426-.783 6.071-2.585 2.076-5.914 4.387-8.773 6.189 2.44 3.489 6.095 7.83 10.161 11.18a189.526 189.526 0 0 1 4.487-14.588l-1.763-.744c.9-3.055 2.193-6.423 3.486-9.204 2.702-.588 6.5-1.214 9.477-1.41-2.898 7.128-5.64 15-7.44 20.994 3.759-.431 8.615-.705 12.688-.784l-.096.327c4.422-6.515 10.154-13.29 16.349-17.835l-.078-2.31 7.44-.549c.784 6.737-.313 21.072 2.037 24.401l-7.598 3.682c-.783-2.742-1.174-5.914-1.37-9.126-6.893.784-9.909 3.8-11.828 9.048l-6.052-3.585zM51.19 46.85c0 4.543-3.29 9.948-8.263 9.948-2.311 0-3.173-1.41-3.173-3.173 0-.665.118-1.41.353-2.154l-1.332-.47c1.841-5.366 4.582-8.42 8.969-8.42 2.506 0 3.446 2.036 3.446 4.268zm72.335 4.856l1.84 2.664c-.117-1.724-.117-3.486-.117-5.21 0-1.723 0-3.368.04-4.974-2.39 2.233-5.327 5.64-6.854 7.912a152.03 152.03 0 0 1 5.09-.392zm37.832-15.588l6.893 2.663c-3.447 6.58-6.815 15.824-8.342 22.756l-7.324 1.645c.157-1.37.392-2.741.627-4.112-2.898-4.23-5.209-8.578-6.501-13.278-1.724 4.778-3.016 10.967-3.917 16.646l-7.088 1.724c1.527-8.93 3.955-17.822 6.814-24.833 2.507-1.057 6.188-2.115 9.36-2.741.353 5.6 1.92 10.066 4.778 13.473 1.175-4.582 2.78-9.713 4.7-13.943zm32.349 11.789l1.527 1.175c-2.624 6.502-9.712 12.455-19.425 14.296l-3.055-2.428-.979 2.507-5.483-.353c1.841-6.815 4.034-13.709 6.07-19.701l-3.289-4.23c4.778-2.037 9.556-3.016 13.668-3.016 6.971 0 12.023 2.741 12.023 7.598 0 1.254-.352 2.624-1.057 4.152zm-6.266-2.154c0-2.468-1.684-3.643-4.935-3.643-.705 0-1.527.04-2.389.157-1.684 4.66-3.799 10.81-5.091 15.667 5.365-1.802 12.415-5.601 12.415-12.181zM223 46.928c0 1.292-.157 2.624-.47 3.995l-1.449.196c-1.919 7.324-6.736 12.416-14.099 12.416-6.893 0-10.378-4.935-10.378-10.615 0-8.969 6.775-16.724 16.018-16.724 6.892 0 10.378 4.543 10.378 10.732zm-7.363-.157c0-2.193-1.018-4.152-3.72-4.152-4.152 0-6.932 3.055-8.616 8.421l1.37.47a6.946 6.946 0 0 0-.274 1.959c0 1.84.901 3.368 3.33 3.368 4.777 0 7.91-5.797 7.91-10.066z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "orl-filter",
                        width: "104.2%",
                        height: "125%",
                        x: "-2.1%",
                        y: "-6.2%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-30 -36)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#000",
                        filter: "url(#orl-filter)",
                        xlinkHref: "#orl-path"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#FFF",
                        xlinkHref: "#orl-path"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/SanDiego.tsx


function SanDiego() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "209",
        height: "36",
        viewBox: "0 0 209 36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "sd-path",
                        d: "M53.853 44.28c.166 1.374-2.12 2.165-3.16 2.165-1.12 0-1.495-.54-2.91-.54-4.404 0-12.883 2.745-16.167 4.66 3.49 1.414 8.978 2.58 12.26 2.912.874.083 2.91 2.33 3.16 4.203a2.365 2.365 0 0 1-.914 2.164c-1.413 1.04-8.645 4.078-10.6 4.078-2.12 0-5.402-1.914-5.527-2.788-.04-.458.042-.79.333-1.124.79-1.248 4.198-.957 10.016-3.204-3.574-.874-11.513-1.082-14.214-3.662-.748-.707-.998-1.83-1.08-2.58-.126-.998-.084-2.663.997-3.62 2.078-1.83 12.51-6.49 20.45-6.49 2.66 0 4.987.79 6.9 2.87.206.29.414.624.456.957zm24.48 16.063c.21 1.706-.706 2.705-2.618 2.705-1.205 0-3.034-.458-3.907-1.623-.54-.75-1.288-3.662-1.58-4.785-3.407.832-7.688 1.415-9.434 1.623-1.164 2.288-1.995 4.702-3.034 7.074-.167.333-3.034 2.663-3.866 2.663-1.04 0-2.286-.624-2.37-1.873-.25-4.41 10.35-25.924 11.597-26.715a7.64 7.64 0 0 1 3.784-1.04c.914 0 2.286.208 3.2 1.165 2.743 2.996 7.814 17.228 8.23 20.806zm-10.016-9.82c-.54-1.54-1.372-3.83-1.954-5.285-.706 1.373-1.828 3.787-2.91 6.408 2.038-.624 3.7-.957 4.864-1.123zm38.654-8.572c-.29-1.955-2.45-4.077-4.696-4.077-.872 0-1.828.416-2.036 1.498-.416 2.164-.29 9.03-.166 13.275-1.33-1.248-2.91-2.788-4.49-4.286-3.2-3.08-6.442-6.118-6.982-6.493-.665-.457-1.413-.5-1.83-.5-1.12 0-3.2.667-3.033 2.33.25 2.748-.374 14.44-.125 16.52.167 1.458 2.286 4.12 4.53 4.12 1.33 0 1.954-.873 2.037-1.79.124-1.496.083-6.78-.042-10.776 1.33 1.25 2.618 2.498 3.948 3.746 2.827 2.663 5.695 5.368 6.775 5.992.625.375 1.29.417 1.705.417 1.33 0 4.074-1.04 3.99-2.705-.332-4.827.167-9.57.416-14.357.043-1.165.084-2.247 0-2.912zm42.313 5.95c.873 7.325-15.42 15.19-19.12 15.897-.166.042-.332.042-.498.042-1.455 0-3.408-2.415-3.866-6.2-.79-6.535 1.163-16.688 1.58-16.73 2.202-.25 4.24-.333 6.026-.333 5.777 0 9.6 1.04 11.18 1.956 1.954 1.124 4.364 2.58 4.697 5.368zm-6.442-.58l-.5-.293c-3.157-1.83-10.1-1.082-10.348-.915-.58.458-.207 6.49.125 10.237 5.445-2.58 9.56-6.743 10.724-9.03zm17.624.79c-.084-.625-.208-1.332-.458-1.83-.79-1.625-3.075-1.874-3.907-1.874-.79 0-1.954.25-2.37 1.04-.582 1.04-.54 7.657-.124 10.903.083.83.25 1.788.54 2.37.54 1 2.12 2.872 3.408 2.872.582 0 1.04-.167 1.372-.416 1.122-.75 1.953-9.446 1.538-13.067zm23.816-8.78c-.125-1.624-4.365-3.33-5.902-3.33-1.247 0-2.95.29-4.656.624-1.787.375-3.782.79-5.86 1.082-1.538.208-1.704 1.54-1.62 2.164.04.54.29 1.04.498 1.54-.79 5.992-1.538 12.234-.79 18.434.374 2.954 1.33 8.114 5.653 8.114.582 0 1.247-.166 1.787-.333 2.16-.582 9.81-2.04 9.518-4.452-.125-.957-4.156-2.622-5.777-2.622-1.58 0-3.16.542-4.654.917-.084-.583 0-2.247-.084-2.87 0-.126-.04-.21-.04-.334 1.537-.458 4.654-1.457 6.15-1.457h.416c1.288 0 3.574-1.04 3.7-2.663-.21-1.58-3.7-2.205-6.402-2.164-1.454 0-2.7.374-3.99.79.25-2.913.665-7.615.956-9.737 2.203-.54 4.447-.833 6.65-1.29 2.536-.54 4.49-1.79 4.448-2.414zm26.31 13.69c-.333-2.664-5.695-4.495-6.817-4.495-3.408 0-7.48.625-9.393 2.206-.333.292-.873.79-.832 1.29.208 1.416 2.827 1.624 3.658 1.582l6.276-.25c-.83.833-5.445 2.955-10.183 2.955-.915 0-2.08-.416-2.33-.916-.747-1.497.21-2.953 1.248-4.243 2.453-3.038 7.4-5.493 11.597-6.408 1.496-.334 2.618-1.125 2.452-2.33-.208-1.708-3.99-3.164-5.445-3.164-5.57 0-16.25 9.07-15.503 15.313.082.5.25 1.04.54 1.497 1.87 2.87 4.862 5.077 8.727 5.077 2.744 0 9.934-1.04 15.462-6.575.415-.417.623-.958.54-1.54zM230 51.147c.04 4.16-4.406 9.238-9.27 9.238-4.53 0-7.73-3.412-8.104-6.783-.5-3.91 2.452-10.86 8.978-10.86.706 0 1.912.04 3.034.83 2.078.21 4.78 1.666 5.28 5.952.082.5.082 1.04.082 1.623zm-6.07-3.08h-.165c-2.618-.083-5.943 4.162-5.694 6.492.042.125.042.333.25.333 1.206 0 3.367-1.248 4.032-2.205.83-1.207 1.455-3.413 1.58-4.62z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "sd-filter",
                        width: "103.9%",
                        height: "125%",
                        x: "-2%",
                        y: "-6.2%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-23 -36)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#000",
                        filter: "url(#sd-filter)",
                        xlinkHref: "#sd-path"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#FFF",
                        xlinkHref: "#sd-path"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/SanFrancisco.tsx


function SanFrancisco() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sf-svg-wrapper",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "288",
            height: "36",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            id: "sf-path",
                            d: "M.553 56.925C.395 57.874 0 63.214 0 65.705c0 .792.079.91.87 1.108C3.712 67.565 6.794 68 10.468 68c8.414 0 13.51-4.153 13.51-9.889 0-4.193-2.567-7.001-9.441-9.612-3.635-1.384-4.622-2.65-4.622-5.023 0-2.215 1.461-3.323 3.476-3.323 1.501 0 2.528.435 3.635 1.543 1.027 1.028 1.738 3.362 2.449 5.26.118.317.237.396 1.146.396.908 0 1.066-.079 1.066-.395v-7.041c0-.791-.079-.87-.869-1.028a24.225 24.225 0 0 0-4.938-.475c-9.679 0-15.486 3.48-15.486 8.94 0 4.706 2.41 7.515 9.402 10.046 4.346 1.582 5.175 3.046 5.175 5.182 0 2.215-1.382 3.679-4.227 3.679-1.896 0-3.042-.712-4.148-1.82-1.264-1.266-2.805-4.786-3.832-7.515-.118-.317-.237-.396-1.145-.396-.909 0-1.027.08-1.067.396zM41.757 68c-2.331 0-3.99-1.582-4.978-5.023C35.515 66.14 33.105 68 30.221 68c-3.042 0-5.135-2.452-5.135-5.538 0-2.413.75-3.797 2.804-4.905 1.857-.988 4.82-1.859 8.573-2.69v-1.265c0-2.848-.87-4.588-2.37-4.588-.395 0-.553.118-.632.632l-.277 1.9c-.395 2.847-2.054 4.192-4.266 4.192-1.225 0-2.331-.752-2.331-2.215 0-2.532 4.898-6.408 10.943-6.408 5.372 0 7.9 2.136 7.9 5.973v7.278c0 3.164.633 3.243 1.7 2.531.118-.079.157-.118.236-.118.356 0 .948.87.948 1.107 0 .198-.158.356-.395.594l-.158.158C45.391 67.01 43.692 68 41.757 68zm-6.005-5.34c.395 0 .592-.158.71-.277v-2.808c0-.87-.355-1.503-.829-1.978-.513-.514-1.145-.752-1.54-.752-.79 0-1.146.475-1.146 1.662 0 2.215 1.501 4.153 2.805 4.153zm39.623 4.153c0-.712-.079-.83-.316-.87l-1.343-.277c-.395-.079-.474-.158-.474-.554V53.88c0-4.272-2.568-6.764-6.716-6.764-3.476 0-6.005 2.334-7.071 4.667 0-2.254.158-3.639.158-4.311 0-.277-.75-.593-1.027-.593-.119 0-.198.04-.316.118-3.16 2.255-6.242 4.193-9.482 5.459-.237.079-.316.158-.316.751 0 .633.08.712.316.752l1.344.237c.395.08.474.119.474.515v10.402c0 .396-.08.475-.474.554l-1.344.277c-.237.04-.316.158-.316.87s.08.831.316.831c.909 0 3.516-.277 6.4-.277 2.884 0 5.175.277 6.084.277.237 0 .316-.119.316-.83 0-.713-.079-.792-.316-.87l-1.067-.278c-.395-.118-.474-.158-.474-.554V52.455c.198-.08.593-.119.87-.119 2.646 0 3.515 1.306 3.515 4.984v7.792c0 .396-.079.436-.474.554l-1.066.277c-.237.08-.316.158-.316.87s.079.831.316.831c.908 0 3.239-.277 6.123-.277 2.884 0 5.452.277 6.36.277.237 0 .316-.119.316-.83zm26.192 0c0 .712-.08.831-.316.831-.909 0-4.03-.277-8.099-.277-3.279 0-6.439.277-7.348.277-.237 0-.316-.119-.316-.83 0-.713.08-.831.316-.87l1.739-.278c.395-.079.474-.158.474-.554v-23.97c0-.395-.08-.475-.474-.554l-1.739-.277c-.237-.04-.316-.158-.316-.87s.08-.83.316-.83c.909 0 5.018.277 12.247.277h.83c4.306 0 10.192-.238 13.115-.238.79 0 .909.119.909.91 0 2.73-.198 6.012-.593 9.098-.04.316-.158.395-1.066.395-.91 0-1.028-.079-1.146-.395-1.067-3.086-1.422-4.154-2.33-6.487-.277-.752-.554-.91-1.344-1.029-1.975-.277-6.044-.593-7.545-.593h-.159c-.395 0-.474.079-.474.474v11.432h2.924c.79 0 .948-.119 1.303-.91.83-1.859 1.146-2.571 1.857-4.153.119-.237.158-.277 1.067-.277.908 0 .987.08.987.396 0 2.294-.04 3.678-.04 5.933 0 2.254.04 3.639.04 5.933 0 .316-.079.396-.987.396-.909 0-.948-.04-1.067-.277-.71-1.583-1.027-2.295-1.857-4.154-.355-.79-.513-.91-1.303-.91h-2.924v10.68c0 .396.08.515.474.554l2.529.277c.237.04.316.158.316.87zm24.098 0c0 .712-.08.831-.316.831-.909 0-3.477-.277-7.546-.277-2.884 0-5.49.277-6.4.277-.236 0-.316-.08-.316-.83 0-.752.08-.831.317-.87l1.343-.278c.395-.079.474-.118.474-.514V54.71c0-.396-.08-.436-.474-.515l-1.343-.237c-.237-.04-.317-.119-.317-.752 0-.593.08-.672.317-.751 3.239-1.266 6.32-3.204 9.48-5.459.12-.079.198-.118.317-.118.276 0 1.027.316 1.027.593 0 .633-.158 3.837-.158 6.408 1.185-3.837 3.397-6.764 5.807-6.764 2.37 0 3.437 1.78 3.437 3.955 0 3.758-2.173 5.617-4.03 5.617-.71 0-1.303-.237-2.172-.83-.948-.673-1.739-1.029-2.252-1.029-.198 0-.435.04-.514.119v10.205c0 .396.08.475.474.514l2.529.277c.237.04.316.158.316.87zM148.143 68c-2.33 0-3.99-1.582-4.978-5.023-1.264 3.164-3.674 5.023-6.557 5.023-3.042 0-5.136-2.452-5.136-5.538 0-2.413.75-3.797 2.805-4.905 1.857-.988 4.82-1.859 8.572-2.69v-1.265c0-2.848-.869-4.588-2.37-4.588-.395 0-.553.118-.632.632l-.277 1.9c-.395 2.847-2.054 4.192-4.266 4.192-1.225 0-2.33-.752-2.33-2.215 0-2.532 4.898-6.408 10.942-6.408 5.373 0 7.9 2.136 7.9 5.973v7.278c0 3.164.633 3.243 1.7 2.531.118-.079.158-.118.237-.118.355 0 .948.87.948 1.107 0 .198-.158.356-.395.594l-.158.158c-2.37 2.373-4.07 3.362-6.005 3.362zm-6.005-5.34c.395 0 .593-.158.711-.277v-2.808c0-.87-.355-1.503-.83-1.978-.513-.514-1.145-.752-1.54-.752-.79 0-1.146.475-1.146 1.662 0 2.215 1.502 4.153 2.805 4.153zm39.624 4.153c0-.712-.08-.83-.316-.87l-1.344-.277c-.395-.079-.474-.158-.474-.554V53.88c0-4.272-2.567-6.764-6.715-6.764-3.477 0-6.005 2.334-7.072 4.667 0-2.254.158-3.639.158-4.311 0-.277-.75-.593-1.027-.593-.118 0-.197.04-.316.118-3.16 2.255-6.242 4.193-9.481 5.459-.237.079-.316.158-.316.751 0 .633.079.712.316.752l1.343.237c.395.08.474.119.474.515v10.402c0 .396-.079.475-.474.554l-1.343.277c-.237.04-.316.158-.316.87s.079.831.316.831c.908 0 3.516-.277 6.4-.277 2.883 0 5.175.277 6.083.277.237 0 .316-.119.316-.83 0-.713-.079-.792-.316-.87l-1.066-.278c-.395-.118-.474-.158-.474-.554V52.455c.197-.08.592-.119.869-.119 2.647 0 3.516 1.306 3.516 4.984v7.792c0 .396-.08.436-.474.554l-1.067.277c-.237.08-.316.158-.316.87s.079.831.316.831c.909 0 3.24-.277 6.123-.277 2.884 0 5.452.277 6.36.277.238 0 .317-.119.317-.83zm21.332-4.588c.158-.396-.83-1.108-1.185-.83-.988.83-1.817 1.265-2.963 1.265-1.264 0-2.054-.356-3.24-1.543-2.37-2.373-4.147-7-4.147-10.442 0-1.503.592-2.097 1.422-2.097.869 0 1.422.475 2.884 3.244 1.145 2.176 2.45 3.283 4.227 3.283 1.778 0 2.963-1.187 2.963-2.73 0-2.61-2.805-5.26-7.822-5.26-6.993 0-12.168 4.272-12.168 10.6 0 6.171 4.267 10.285 10.153 10.285 4.899 0 8.652-2.808 9.876-5.775zm8.73-17.127c2.648 0 4.544-1.978 4.544-4.55 0-2.57-1.896-4.548-4.543-4.548-2.647 0-4.543 1.978-4.543 4.549 0 2.57 1.896 4.549 4.543 4.549zm-6.913 22.546c.87 0 3.516-.277 6.4-.277 2.884 0 5.452.277 6.36.277.237 0 .316-.119.316-.83 0-.713-.079-.831-.316-.87l-1.343-.278c-.395-.079-.474-.158-.474-.554v-9.414c0-4.865.316-7.555.316-8.227 0-.277-.75-.593-1.027-.593-.118 0-.197.04-.316.118-3.16 2.176-6.676 4.193-9.916 5.459-.237.079-.316.158-.316.751 0 .633.08.712.316.752l1.344.237c.395.08.474.119.474.515v10.402c0 .396-.08.475-.474.554l-1.344.277c-.237.04-.316.158-.316.87s.08.831.316.831zm14.894-7.199c-.198 1.82-.395 4.074-.395 5.538 0 .79.079.87.869 1.107 2.054.633 3.713.91 6.044.91 6.32 0 9.955-3.164 9.955-7.792 0-3.007-1.422-5.34-5.886-6.922-2.647-.95-3.279-1.622-3.279-2.928 0-1.463 1.027-2.017 2.37-2.017 1.304 0 1.976.554 2.37 1.503.396.99.672 1.701 1.225 3.125.119.317.237.396.988.396.75 0 .83-.08.83-.396v-4.707c0-.791-.08-.87-.87-.989-1.5-.198-2.962-.356-4.385-.356-6.439 0-9.955 3.165-9.955 7.08 0 3.402 1.185 5.617 6.005 7.041 2.805.831 3.555 1.78 3.555 3.204 0 1.464-1.027 2.334-2.765 2.334-1.185 0-2.054-.356-2.726-1.503-.671-1.147-1.303-2.65-2.094-4.628-.118-.316-.237-.396-.987-.396-.711 0-.83.08-.87.396zm38.32 1.78c.157-.396-.83-1.108-1.186-.83-.987.83-1.817 1.265-2.963 1.265-1.264 0-2.054-.356-3.239-1.543-2.37-2.373-4.148-7-4.148-10.442 0-1.503.593-2.097 1.422-2.097.87 0 1.422.475 2.884 3.244 1.146 2.176 2.45 3.283 4.227 3.283 1.778 0 2.963-1.187 2.963-2.73 0-2.61-2.805-5.26-7.822-5.26-6.992 0-12.168 4.272-12.168 10.6 0 6.171 4.267 10.285 10.153 10.285 4.899 0 8.652-2.808 9.876-5.775zm1.856-4.51c0-6.724 5.096-10.6 12.405-10.6 6.873 0 11.614 3.876 11.614 10.284C284 64.124 278.904 68 271.595 68c-6.873 0-11.614-3.876-11.614-10.284zm8.612-6.526c0 4.153 2.41 13.053 4.109 14.754.474.475.83.593 1.224.593.79 0 1.462-.514 1.462-2.61 0-4.153-2.41-13.053-4.109-14.754-.474-.475-.83-.594-1.224-.594-.79 0-1.462.515-1.462 2.611z"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                            id: "sf-filter",
                            width: "102.8%",
                            height: "125%",
                            x: "-1.4%",
                            y: "-6.2%",
                            filterUnits: "objectBoundingBox",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                    dy: "2",
                                    in: "SourceAlpha",
                                    result: "shadowOffsetOuter1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                    in: "shadowOffsetOuter1",
                                    result: "shadowBlurOuter1",
                                    stdDeviation: "1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                    in: "shadowBlurOuter1",
                                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    transform: "translate(2 -36)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            fill: "#000",
                            filter: "url(#sf-filter)",
                            xlinkHref: "#sf-path"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                            fill: "#FFF",
                            xlinkHref: "#sf-path"
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/Seattle.tsx


function Seattle() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "149",
        height: "36",
        viewBox: "0 0 149 36",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        id: "sea-path",
                        d: "M75.087 58.543c0-5.316-3.067-8.332-10.225-10.12-4.142-1.075-5.266-2.404-5.266-4.193 0-2.198 1.79-3.527 4.806-3.527 2.71 0 5.777 1.227 7.925 2.658l1.33-4.344C71.61 37.43 68.236 36 64.452 36c-6.596 0-10.584 3.63-10.584 8.64 0 4.395 2.556 7.82 8.998 9.405 5.01 1.33 6.442 2.556 6.442 5.112 0 2.71-2.352 4.242-5.42 4.242-4.192 0-7.413-2.2-9.458-4.14L53 64.165C55.096 66.006 58.778 68 63.89 68c5.778 0 11.197-2.863 11.197-9.457zM99.27 53.43c0 .973-.152 2.3-.357 3.068H84.188c-.153 3.374 1.585 7.208 7.516 7.208 2.505 0 5.47-1.125 7.158-2.607v4.293C96.766 67.03 93.545 68 89.864 68c-6.8 0-11.555-4.958-11.555-11.808 0-7.055 5.42-11.502 11.145-11.502 5.624 0 9.816 3.527 9.816 8.74zm-5.367-.1c.51-2.66-1.227-4.857-4.295-4.857-2.505 0-4.653 1.43-5.164 4.856h9.46zm33.233 14.057h-5.368l-.205-3.528c-1.84 2.71-5.113 4.14-8.232 4.14-5.98 0-10.378-5.01-10.378-11.655s4.397-11.655 10.38-11.655c3.118 0 6.39 1.43 8.23 4.14l.206-3.526h5.368v22.083zm-5.675-11.042c0-4.55-2.81-7.26-6.288-7.26s-6.29 2.71-6.29 7.26 2.813 7.26 6.29 7.26 6.29-2.71 6.29-7.26zm24.594-7.157v-3.884H141.4v-6.032h-5.93v6.032h-4.654v3.884h4.653v18.2h5.93v-18.2h4.653zm16.77 0v-3.884h-4.653v-6.032h-5.93v6.032h-4.653v3.884h4.653v18.2h5.93v-18.2h4.654zm9.612 18.2V36.715h-5.93v30.67h5.93zM198 53.43c0 .972-.153 2.3-.358 3.067h-14.725c-.153 3.374 1.585 7.208 7.516 7.208 2.505 0 5.47-1.125 7.158-2.607v4.294c-2.095 1.636-5.316 2.607-8.998 2.607-6.8 0-11.555-4.96-11.555-11.81 0-7.054 5.42-11.5 11.146-11.5 5.624 0 9.817 3.526 9.817 8.74zm-5.368-.102c.51-2.658-1.228-4.856-4.295-4.856-2.506 0-4.653 1.43-5.164 4.856h9.46z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "sea-filter",
                        width: "105.5%",
                        height: "125%",
                        x: "-2.8%",
                        y: "-6.2%",
                        filterUnits: "objectBoundingBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feOffset", {
                                dy: "2",
                                in: "SourceAlpha",
                                result: "shadowOffsetOuter1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                in: "shadowOffsetOuter1",
                                result: "shadowBlurOuter1",
                                stdDeviation: "1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feColorMatrix", {
                                in: "shadowBlurOuter1",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(-51 -36)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#000",
                        filter: "url(#sea-filter)",
                        xlinkHref: "#sea-path"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("use", {
                        fill: "#FFF",
                        xlinkHref: "#sea-path"
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/PopularDestinations/svgs/index.ts











;// CONCATENATED MODULE: ./src/components/PopularDestinations/constants.ts

var imageFolder = "https://s1.pclncdn.com/design-assets/next-landing/assets/images/destinations/popular/";
var DESTINATIONS = [
    {
        driveSearchHref: "/rental-car-deals/new-york.15830.ksp",
        flySearchHref: "/flight-routes/New-York-NYC.ksp",
        staySearchHref: "/hotel-deals/c3000016152/US/New-York/New-York-Hotels.html",
        searchCity: "New York",
        image: "".concat(imageFolder, "new-york-city.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "new-york-city.jpg?opto&auto=webp"),
        svg: NewYork,
        title: "24-HOUR EXCITEMENT",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            2 / 3
        ]
    },
    {
        driveSearchHref: "/rental-car-deals/los-angeles.16078.ksp",
        flySearchHref: "/flight-routes/Los-Angeles-LAX.ksp",
        staySearchHref: "/hotel-deals/c3000001947/US/California/Los-Angeles-Hotels.html",
        searchCity: "Los Angeles",
        image: "".concat(imageFolder, "los-angeles.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "los-angeles.jpg?opto&auto=webp"),
        svg: LosAngeles,
        title: "CUTTING-EDGE COOL",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            1 / 3
        ]
    },
    {
        driveSearchHref: "/rental-car-deals/orlando.9900.ksp",
        flySearchHref: "/flight-routes/Orlando-ORL.ksp",
        staySearchHref: "/hotel-deals/c3000003349/US/Florida/Orlando-Hotels.html",
        searchCity: "Orlando",
        image: "".concat(imageFolder, "orlando.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "orlando.jpg?opto&auto=webp"),
        svg: Orlando,
        title: "THEME PARK PARADISE",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            1 / 3
        ]
    },
    {
        driveSearchHref: "/rental-car-deals/atlanta.11123.ksp",
        flySearchHref: "/flight-routes/Atlanta-Hartsfield-Jackson-ATL.ksp",
        staySearchHref: "/hotel-deals/c3000003496/US/Georgia/Atlanta-Hotels.html",
        searchCity: "Atlanta",
        image: "".concat(imageFolder, "atlanta.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "atlanta.jpg?opto&auto=webp"),
        svg: Atlanta,
        title: "SWEET SOUTHERN CHARM",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            1 / 3
        ]
    },
    {
        driveSearchHref: "/rental-car-deals/dallas.16406.ksp",
        flySearchHref: "/flight-routes/Dallas-A78.ksp",
        staySearchHref: "/hotel-deals/c3000021082/US/Texas/Dallas-Hotels.html",
        searchCity: "Dallas",
        image: "".concat(imageFolder, "dallas.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "dallas.jpg?opto&auto=webp"),
        svg: Dallas,
        title: "FOOD CAPITAL",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            1 / 3
        ]
    },
    {
        driveSearchHref: "/rental-car-deals/san-francisco.13852.ksp",
        flySearchHref: "/flight-routes/San-Francisco-SFO.ksp",
        staySearchHref: "/hotel-deals/c3000002244/US/California/San-Francisco-Hotels.html",
        searchCity: "San Francisco",
        image: "".concat(imageFolder, "san-francisco.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "san-francisco.jpg?opto&auto=webp"),
        svg: SanFrancisco,
        title: "SOAK UP THE SCENES",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            1 / 3
        ]
    },
    {
        driveSearchHref: "/rental-car-deals/miami.14305.ksp",
        flySearchHref: "/flight-routes/Miami-MIA.ksp",
        staySearchHref: "/hotel-deals/c3000003311/US/Florida/Miami-Hotels.html",
        searchCity: "Miami",
        image: "".concat(imageFolder, "miami.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "miami.jpg?opto&auto=webp"),
        svg: Miami,
        title: "IT'S BEACH TIME",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            2 / 3
        ]
    },
    {
        flySearchHref: "/flight-routes/Denver-Intl-DEN.ksp",
        driveSearchHref: "/rental-car-deals/denver.12493.ksp",
        staySearchHref: "/hotel-deals/c3000002573/US/Colorado/Denver-Hotels.html",
        searchCity: "Denver",
        image: "".concat(imageFolder, "denver.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "denver.jpg?opto&auto=webp"),
        svg: Denver,
        title: "MILE-HIGH MAGIC",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            1 / 3
        ]
    },
    {
        flySearchHref: "/flight-routes/Seattle-Tacoma-Intl-SEA.ksp",
        driveSearchHref: "/rental-car-deals/seattle.7054.ksp",
        staySearchHref: "/hotel-deals/c3000023414/US/Washington/Seattle-Hotels.html",
        searchCity: "Seattle",
        image: "".concat(imageFolder, "seattle.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "seattle.jpg?opto&auto=webp"),
        svg: Seattle,
        title: "PACIFIC NORTHWEST BEAUTY",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            1 / 3
        ]
    },
    {
        driveSearchHref: "/rental-car-deals/san-diego.10760.ksp",
        flySearchHref: "/flight-routes/San-Diego-SAN.ksp",
        staySearchHref: "/hotel-deals/c3000002241/US/California/San-Diego-Hotels.html",
        searchCity: "San Diego",
        image: "".concat(imageFolder, "san-diego.jpg?opto&auto=webp"),
        imageWebP: "".concat(imageFolder, "san-diego.jpg?opto&auto=webp"),
        svg: SanDiego,
        title: "RIDE THE WAVES",
        width: [
            1,
            1,
            1 / 2,
            1 / 2,
            1 / 3
        ]
    }
];
/* harmony default export */ var PopularDestinations_constants = (DESTINATIONS);

;// CONCATENATED MODULE: ./src/components/PopularDestinations/index.tsx





var PopularDestination = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        maxWidth: 1280,
        mx: "auto",
        mb: 5,
        color: "background.lightest",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: "text.heading",
                py: 2,
                px: 3,
                mt: 1,
                textStyle: "heading2",
                children: "Discover deals in every city"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                mx: 2,
                flexWrap: "wrap",
                children: PopularDestinations_constants.map(function(destination) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularDestinations_PopularDestinationTile, {
                        destination: destination
                    }, destination.title);
                })
            })
        ]
    });
};
/* harmony default export */ var PopularDestinations = (PopularDestination);

// EXTERNAL MODULE: ./src/components/MerchModuleWrapper/index.tsx + 5 modules
var MerchModuleWrapper = __webpack_require__(73779);
;// CONCATENATED MODULE: ./src/components/CreditCard/CreditCard.tsx







function CreditCard() {
    var promo = (0,useContentfulVariation/* default */.Z)("creditCardPromo");
    return promo != null ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MerchModuleWrapper/* default */.Z, {
                content: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, promo), {
                    backgroundColor: "background.light"
                }),
                credCardModWrapDefaultDisplay: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                borderColor: "border.base",
                my: 0
            })
        ]
    }) : null;
}

// EXTERNAL MODULE: ./src/constants/promotions/branded-marketing.ts
var branded_marketing = __webpack_require__(69325);
// EXTERNAL MODULE: ./src/components/EmailSignUp/index.tsx + 7 modules
var EmailSignUp = __webpack_require__(86229);
// EXTERNAL MODULE: ./src/components/PromoFeatureBox.tsx + 4 modules
var PromoFeatureBox = __webpack_require__(25379);
// EXTERNAL MODULE: ./src/components/PackagesCarousel/index.tsx + 6 modules
var PackagesCarousel = __webpack_require__(83524);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 238 modules
var es = __webpack_require__(67763);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 41 modules
var parse = __webpack_require__(35337);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isAfter/index.js
var isAfter = __webpack_require__(42699);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/PackagesFill.js
var PackagesFill = __webpack_require__(83976);
// EXTERNAL MODULE: ./node_modules/@pcln/brand/lib-esm/svg-build/HotelsFill.js
var HotelsFill = __webpack_require__(28845);
// EXTERNAL MODULE: ./node_modules/@pcln/cards/lib-esm/ActionCard/ActionCard.js + 1 modules
var ActionCard = __webpack_require__(44130);
// EXTERNAL MODULE: ./src/constants/products.ts
var products = __webpack_require__(27204);
// EXTERNAL MODULE: ./src/utils/local-forage-helper.ts
var local_forage_helper = __webpack_require__(29735);
;// CONCATENATED MODULE: ./src/components/RecentSearchCards.tsx





function RecentSearchCards_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    RecentSearchCards_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecentSearchCards_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-wrap: wrap;\n  margin-left: auto;\n  margin-right: auto;\n  max-width: 1280px;\n  padding-left: 28px;\n"
    ]);
    RecentSearchCards_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













var DATE_FORMAT = "E, MMM dd";
function getDisplayName(location) {
    if (!location) {
        return "";
    }
    var cityName = location.cityName, stateCode = location.stateCode, countryCode = location.countryCode, itemName = location.itemName;
    var displayCode = stateCode && stateCode !== "--" ? stateCode : countryCode;
    return cityName && displayCode ? "".concat(cityName, ", ").concat(displayCode) : itemName;
}
var filterFalsey = function(primary, fallback) {
    return function(item) {
        var locations = [
            item[primary],
            item[fallback],
            item.locationObject
        ].filter(Boolean).filter((0,es/* complement */.CyQ)(es/* isEmpty */.xbD));
        return locations === null || locations === void 0 ? void 0 : locations[0];
    };
};
// we need endLocation & startLocation as a fallback because
// next-landing uses these keys to save package searches
// @todo remove the fallbacks after d-home is deprecated for some time
var getStartLocation = filterFalsey("startLocationObject", "startLocation");
var getEndLocation = filterFalsey("endLocationObject", "endLocation");
function formatDates(param) {
    var _startDate = param.startDate, startDate = _startDate === void 0 ? "" : _startDate, _endDate = param.endDate, endDate = _endDate === void 0 ? "" : _endDate;
    if (!startDate) {
        var today = new Date();
        var tomorrow = (0,add/* default */.Z)(today, {
            days: 1
        });
        return [
            (0,format/* default */.Z)(today, DATE_FORMAT),
            (0,format/* default */.Z)(tomorrow, DATE_FORMAT)
        ];
    }
    return [
        (0,format/* default */.Z)((0,parse/* default */.Z)(startDate, "yyyyMMdd", new Date()), DATE_FORMAT),
        (0,format/* default */.Z)((0,parse/* default */.Z)(endDate, "yyyyMMdd", new Date()), DATE_FORMAT)
    ];
}
var RecentSearchCards_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-c281f9a-0"
})(RecentSearchCards_templateObject(), (0,utils_utils/* getPaletteColor */.ow)("background.lightest"));
var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c281f9a-1"
})(RecentSearchCards_templateObject1());
var dataWithStartDateGreaterThanOrEqualToToday = function(item) {
    var currentDate = new Date();
    var startDate = (0,parse/* default */.Z)(item.startDate, "yyyyMMdd", new Date());
    return (0,isAfter/* default */.Z)(startDate, currentDate) || (0,isSameDay/* default */.Z)(startDate, currentDate);
};
function RecentSearchCards() {
    var ref = (0,react.useState)([]), recentSearches = ref[0], setRecentSearches = ref[1];
    (0,react.useEffect)(function() {
        (0,local_forage_helper/* getPersistedSearchDataByKeys */.xl)([
            local_forage_helper/* HOTEL_SEARCH_DATA */.yO,
            local_forage_helper/* PACKAGE_SEARCH_DATA */.Tw
        ], true).then(function(sortedData) {
            var distinctData = sortedData.reduce(function(accumulator, item) {
                var key = (0,local_forage_helper/* generateRecentSearchDataKey */.BF)(item);
                if (accumulator === null || accumulator === void 0 ? void 0 : accumulator[key]) return accumulator;
                if (dataWithStartDateGreaterThanOrEqualToToday(item)) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, accumulator), (0,_define_property/* default */.Z)({}, key, item));
                }
                return accumulator;
            }, {});
            var actualData = Object.values(distinctData);
            var atMostTwoRecentSearches = actualData.slice(0, 2);
            setRecentSearches(atMostTwoRecentSearches);
        });
    }, []);
    var recentSearchCards = recentSearches.map(function(item, index) {
        var product = (0,local_forage_helper/* getProductType */.rC)(item);
        var startDisplayName = (0,es/* compose */.qCK)(getDisplayName, getStartLocation)(item);
        var endDisplayName = (0,es/* compose */.qCK)(getDisplayName, getEndLocation)(item);
        var ref = (0,_sliced_to_array/* default */.Z)(formatDates(item), 2), startDate = ref[0], endDate = ref[1];
        var handleOnClick = function() {
            (0,Hotels_SearchForm_utils/* handleSubmitForHotels */.Ky)(item);
            analytics/* default.fireEvent */.Z.fireEvent({
                category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                action: "Personalized Shortcut",
                label: "Recent Search Shortcut"
            });
        };
        var iconNode = product === products/* VACATION_PACKAGE_PRODUCT_TYPE */.nu ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PackagesFill/* default */.Z, {
            size: "24px"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(HotelsFill/* default */.Z, {
            size: "24px"
        });
        var productType = product === products/* VACATION_PACKAGE_PRODUCT_TYPE */.nu ? products/* BUNDLE_AND_SAVE_PRODUCT_TYPE */.Pz : products/* HOTEL_PRODUCT_TYPE */.kd;
        var startLocation = startDisplayName && startDisplayName !== endDisplayName ? "".concat(startDisplayName, " - ") : "";
        var title = "".concat(startLocation).concat(endDisplayName);
        var subTitle = "".concat(startDate, " - ").concat(endDate);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            width: "388px",
            mr: index === 0 ? "36px" : 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionCard/* default */.Z, {
                titleWidth: "300px",
                icon: iconNode,
                title: title,
                subTitle: subTitle,
                heading: productType,
                onClick: handleOnClick
            }, item.timestamp || index)
        });
    });
    return recentSearchCards.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSearchCards_Wrapper, {
        mb: [
            4,
            null,
            null,
            5,
            4
        ],
        pt: 3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlex, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    width: "100%",
                    mb: 2,
                    textStyle: "heading5",
                    children: "Your Recent Searches"
                }),
                recentSearchCards
            ]
        })
    }) : null;
}

// EXTERNAL MODULE: ./src/components/CrossSell/index.tsx + 16 modules
var CrossSell = __webpack_require__(90020);
// EXTERNAL MODULE: ./src/hooks/useMostRecentFutureBooking.ts
var useMostRecentFutureBooking = __webpack_require__(81850);
// EXTERNAL MODULE: ./src/hooks/useExpressDealModal.ts
var useExpressDealModal = __webpack_require__(77185);
// EXTERNAL MODULE: ./src/components/Hotels/ExpressDeal/ExpressDealModal.tsx
var ExpressDealModal = __webpack_require__(55173);
// EXTERNAL MODULE: ./src/components/Promos/MarketingTout/MarketingTout.tsx
var MarketingTout = __webpack_require__(51453);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/react-hook-form.es.js
var react_hook_form_es = __webpack_require__(64298);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/FormField/FormField.js
var FormField = __webpack_require__(23341);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Input/Input.js
var Input = __webpack_require__(84498);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(86741);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Smartphone.js
var Smartphone = __webpack_require__(25375);
;// CONCATENATED MODULE: ./src/components/PhoneFormEntry/PhoneEntry.tsx



function PhoneEntry_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n"
    ]);
    PhoneEntry_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.ZP).withConfig({
    componentId: "sc-b1fc5bc5-0"
})(PhoneEntry_templateObject());
function PhoneEntry(param) {
    var _clientGUID = param.clientGUID, clientGUID = _clientGUID === void 0 ? "" : _clientGUID, _ipAddr = param.ipAddr, ipAddr = _ipAddr === void 0 ? "" : _ipAddr, _referral = param.referral, referral = _referral === void 0 ? {} : _referral;
    // eslint-disable can be removed after upgrade to react-hook-form v7 - https://github.com/react-hook-form/react-hook-form/issues/2887
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var ref = (0,react_hook_form_es/* useForm */.cI)(), register = ref.register, watch = ref.watch, handleSubmit = ref.handleSubmit, setValue = ref.setValue;
    var watchNumber = watch("phoneNumber");
    var ref1 = (0,react.useState)(false), success = ref1[0], setSuccess = ref1[1];
    var ref2 = (0,react.useState)(null), error = ref2[0], setError = ref2[1];
    var handleSubmitNumber = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var phoneNumber, validFormat, URL, submission, response, body, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        phoneNumber = values.phoneNumber;
                        validFormat = /^\d{3}[-]\d{3}[-]\d{4}$/.test(phoneNumber);
                        if (!validFormat) return [
                            3,
                            8
                        ];
                        URL = "/svcs/eng/gblsvcs/v1/sms/send";
                        submission = {
                            cguid: clientGUID,
                            guid: "98181227f7c74e28a6b43c9e7f3ed879",
                            ipAddr: ipAddr,
                            pageId: "DESK_HP_T2D_TXT",
                            refClickId: referral.clickId,
                            refId: referral.id,
                            refSourceId: referral.sourceId,
                            smsContent: "TEST",
                            toPhoneNo: phoneNumber
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            fetch(URL, {
                                method: "POST",
                                body: JSON.stringify(submission),
                                headers: {
                                    "content-type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!response.ok) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        body = _state.sent();
                        if (body.messageSent) {
                            setSuccess(true);
                        } else {
                            setError("Please check the number you have entered");
                            throw new Error(body.errorDesc || "Phone registration failure");
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setError("Please check the number you have entered");
                        throw new Error(response.statusText || "Phone registration failure");
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        setError("Please check the number you have entered");
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setError("Please check the number you have entered");
                        _state.label = 9;
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitNumber(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        mb: 4,
        children: success ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                bold: true,
                color: "success",
                textAlign: "center",
                children: [
                    "We've sent a link to the number you provided.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Happy Savings!"
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            "aria-label": "phone-number-entry-form",
            onSubmit: handleSubmit(handleSubmitNumber),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                height: "48px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        width: 1,
                        mr: 2,
                        bg: "background.lightest",
                        borderRadius: "xl",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Smartphone/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                        type: "tel",
                                        style: {
                                            width: "100%"
                                        },
                                        name: "phoneNumber",
                                        ref: register({
                                            required: true
                                        }),
                                        placeholder: "Enter your phone number",
                                        value: watchNumber || null,
                                        onChange: function(e) {
                                            var number = e.target.value;
                                            var formatNumber = number.replace(/[\s(|).-]/g, "");
                                            var match = formatNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
                                            if (match) {
                                                formatNumber = "".concat(match[1], "-").concat(match[2], "-").concat(match[3]);
                                            }
                                            setValue("phoneNumber", formatNumber);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                children: error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    bottom: true,
                                    right: true,
                                    color: "error",
                                    children: error
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                        size: "large",
                        width: "initial",
                        type: "submit",
                        children: "Send Link"
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/hooks/useExtendStayBooking.ts
var useExtendStayBooking = __webpack_require__(83405);
// EXTERNAL MODULE: ./src/constants/reasons.tsx
var reasons = __webpack_require__(94228);
// EXTERNAL MODULE: ./src/components/ConditionalRender/index.tsx + 2 modules
var ConditionalRender = __webpack_require__(93314);
// EXTERNAL MODULE: ./src/components/ExtendStay/index.tsx + 2 modules
var ExtendStay = __webpack_require__(38292);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/SilhouetteMarketingModule/SilhouetteMarketingModule.js + 2 modules
var SilhouetteMarketingModule = __webpack_require__(26070);
// EXTERNAL MODULE: ./src/hooks/smsOptIn/useSmsDisclaimerQueryArgs.ts
var useSmsDisclaimerQueryArgs = __webpack_require__(95846);
// EXTERNAL MODULE: ./node_modules/@pcln/marketing/dist/esm/OptInCard/OptInCard.js + 8 modules
var OptInCard = __webpack_require__(19636);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Bag.js
var Bag = __webpack_require__(88813);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Help.js
var Help = __webpack_require__(45932);
;// CONCATENATED MODULE: ./src/hooks/useHandleAppDownloadSubmit.ts






function useHandleAppDownloadSubmit() {
    var formatPhoneNumber = function formatPhoneNumber(phoneNumber) {
        return phoneNumber.replace(/[^\d]/g, "").replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$2-$3-$4");
    };
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), clientGUID = ref.webstats.clientGUID, ipAddr = ref.locale.ipAddr, _referral = ref.referral, clickId = _referral.clickId, id = _referral.id, sourceId = _referral.sourceId;
    var ref1 = (0,react.useState)("NOT_SIGNED_UP"), signUpState = ref1[0], setSignUpState = ref1[1];
    var handleSubmitNumber = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values) {
            var phoneNumber, formattedNumber, validFormat, URL, submission, response, body, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        phoneNumber = values.phoneNumber;
                        formattedNumber = formatPhoneNumber(phoneNumber);
                        validFormat = /^\d{3}[-]\d{3}[-]\d{4}$/.test(formattedNumber);
                        URL = "/svcs/eng/gblsvcs/v1/sms/send";
                        if (!validFormat) return [
                            3,
                            8
                        ];
                        submission = {
                            cguid: clientGUID,
                            guid: "aaa1289772a44ef6bbec486b0c907c11",
                            ipAddr: ipAddr,
                            pageId: "DESK_HP_T2D_TXT",
                            refClickId: clickId,
                            refId: id,
                            refSourceId: sourceId,
                            smsContent: "TEST",
                            toPhoneNo: formattedNumber
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        setSignUpState("SIGN_UP_IN_PROGRESS");
                        return [
                            4,
                            fetch(URL, {
                                method: "POST",
                                body: JSON.stringify(submission),
                                headers: {
                                    "content-type": "application/json"
                                }
                            })
                        ];
                    case 2:
                        response = _state.sent();
                        if (!response.ok) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            response.json()
                        ];
                    case 3:
                        body = _state.sent();
                        if (body.messageSent) {
                            analytics/* default.fireEvent */.Z.fireEvent({
                                category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                                action: "promo trio",
                                label: "app download"
                            });
                            setSignUpState("SIGNED_UP");
                        } else {
                            setSignUpState("SIGN_UP_ERROR");
                            throw new Error(body.errorDesc || "Phone registration failure");
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setSignUpState("SIGN_UP_ERROR");
                        throw new Error(response.statusText || "Phone registration failure");
                    case 5:
                        return [
                            3,
                            7
                        ];
                    case 6:
                        err = _state.sent();
                        setSignUpState("SIGN_UP_ERROR");
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            3,
                            9
                        ];
                    case 8:
                        setSignUpState("SIGN_UP_ERROR");
                        _state.label = 9;
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmitNumber(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return [
        handleSubmitNumber,
        signUpState
    ];
}

// EXTERNAL MODULE: ./src/components/AppDownloadOptIn/utils.tsx
var AppDownloadOptIn_utils = __webpack_require__(79876);
;// CONCATENATED MODULE: ./src/components/AppDownloadOptIn/AppDownloadOptIn.tsx











function AppDownloadOptIn() {
    var ref = (0,_sliced_to_array/* default */.Z)(useHandleAppDownloadSubmit(), 2), handleSubmitNumber = ref[0], signUpState = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                mr: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptInCard/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, AppDownloadOptIn_utils/* CONTENT */.P8), {
                    signUpState: signUpState,
                    handleFormSubmit: handleSubmitNumber
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                style: {
                    gap: 16
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionCard/* default */.Z, {
                        titleWidth: "300px",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bag/* default */.Z, {
                            color: "primary"
                        }),
                        title: "My Trips",
                        caption: "Quickly find your booking reservations",
                        isIconRounded: false,
                        onClick: AppDownloadOptIn_utils/* trackMyTrips */.y3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionCard/* default */.Z, {
                        titleWidth: "300px",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Help/* default */.Z, {}),
                        title: "Help Center",
                        isIconRounded: false,
                        caption: "We are always Here for you - reach us 24hrs a day, 7 days a week",
                        onClick: AppDownloadOptIn_utils/* trackHelpCenter */.Tl
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Home/HomeContent/index.tsx


































var expressDealQSKey = "expressdeal";
var expressDealQSValue = "y";
function HomeContent() {
    var mostRecentFutureBooking = (0,useMostRecentFutureBooking/* default */.Z)();
    var extendData = (0,useExtendStayBooking/* default */.Z)();
    var isOpen = (0,useExpressDealModal/* default */.Z)(expressDealQSKey, expressDealQSValue).isOpen;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), clientGUID = ref.webstats.clientGUID, ipAddr = ref.locale.ipAddr, referral = ref.referral, customer = ref.customer;
    var isWhyPclnLower = (0,useSeti/* default */.Z)("HP_BOTTOM_WHY_PRICELINE") === "VARIANT";
    var AdBannerContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AdBanner/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "div-gpt-ad-1614716188275-0"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                    borderColor: "border.base",
                    my: 0
                })
            ]
        });
    };
    var heroSpacing = {
        mt: [
            0,
            null,
            null,
            -4,
            0
        ],
        mb: 3,
        style: {
            position: "relative"
        }
    };
    var smsDisclaimerQueryArgs = (0,useSmsDisclaimerQueryArgs/* default */.Z)();
    var CrossSellContent = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: mostRecentFutureBooking ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                mx: "auto",
                p: 3,
                maxWidth: "1280px"
            }, heroSpacing), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSell/* default */.Z, {
                    booking: mostRecentFutureBooking
                })
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoFeatureBox/* default */.Z, {})
        });
    };
    var promoCollection = (0,useContentful/* default */.Z)("promoCollection");
    var promoItems = (promoCollection === null || promoCollection === void 0 ? void 0 : promoCollection.items) || [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpressDealModal/* default */.Z, {
                isModalOpen: isOpen,
                gaCategory: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG,
                qsKey: expressDealQSKey,
                qsValue: expressDealQSValue
            }),
            !extendData && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSearchCards, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                md: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalRender/* default */.ZP, {
                    experimentCode: "HP_XSELL_V_MEDIACARDS",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Original */.gg, {
                            children: extendData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                mx: "auto",
                                p: 3,
                                maxWidth: "1280px"
                            }, heroSpacing), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendStay/* default */.Z, (0,_object_spread/* default */.Z)({}, extendData))
                            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSellContent, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalRender/* Experiment */.KS, {
                            children: [
                                (extendData || mostRecentFutureBooking) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    mx: "auto",
                                    p: 3,
                                    maxWidth: "1280px"
                                }, heroSpacing), {
                                    pb: 4,
                                    children: extendData ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendStay/* default */.Z, (0,_object_spread/* default */.Z)({}, extendData)) : mostRecentFutureBooking && /*#__PURE__*/ (0,jsx_runtime.jsx)(CrossSell/* default */.Z, {
                                        booking: mostRecentFutureBooking
                                    })
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoFeatureBox/* default */.Z, {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* default */.ZP, {
                experimentCode: "HP_APPBANNER_TRIO",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Experiment */.KS, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            m: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDownloadOptIn, {})
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* default */.ZP, {
                experimentCode: "HP_SMS_COMPONENT",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalRender/* Experiment */.KS, {
                    children: [
                        mostRecentFutureBooking ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: [
                                5,
                                4,
                                0,
                                4
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: [
                                5,
                                5,
                                0,
                                5
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SmsOptIn/* default */.Z, {
                            disclaimerQueryArgs: smsDisclaimerQueryArgs
                        })
                    ]
                })
            }),
            !isWhyPclnLower && /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyPricelineBanner/* default */.Z, {
                content: reasons/* REASONS_HOME */.Y
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MarketingTout/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                maxWidth: "1280px",
                margin: "auto",
                px: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SilhouetteMarketingModule/* default */.Z, (0,_object_spread/* default */.Z)({}, branded_marketing/* default */.Z))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PackagesCarousel/* default */.Z, {
                heading: "Don't miss these hotel + flight deals",
                rudderstack: {
                    rudderEvent: true,
                    type: "explicit",
                    subType: "cross_sell",
                    category: "impression",
                    parentProduct: "FLY:STAY",
                    cguid: clientGUID,
                    emailAddress: customer.emailAddress,
                    source: "homepage",
                    label: "Flight + Hotel Deal"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* default */.ZP, {
                experimentCode: "HP_APPBANNER_TRIO",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConditionalRender/* Original */.gg, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            color: "background.light",
                            mx: 4,
                            boxShadowSize: "sm",
                            my: 2,
                            borderRadius: "xl",
                            py: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mx: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDownload/* AppDownload */.B, {
                                    imageMinHeight: "383px",
                                    ctaArea: /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneEntry, {
                                        clientGUID: clientGUID,
                                        ipAddr: ipAddr,
                                        referral: referral
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSignUp/* EmailSignUpComponent */.mK, {
                sourceId: "LANDING_HOME",
                category: constants_analytics/* ANALYTICS_CATEGORY_HOME */.DG
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailSignUp/* EmailSignUpToast */.Zz, {
                sourceId: "LANDING_HOME_TOAST_DESKTOP"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularDestinations, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoBanners/* default */.Z, {
                merchModules: promoItems
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCard, {}),
            isWhyPclnLower && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyPricelineBanner/* default */.Z, {
                        content: reasons/* REASONS_HOME */.Y
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                        borderColor: "border.base",
                        my: 0
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdBannerContent, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/Home/HomeDesktop.tsx










var SunsetImage = "https://s1.pclncdn.com/design-assets/next-landing/assets/images/hero/pcln-hp-hero-sunset.png";
var defaultHeroProps = {
    searchForms: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm, {}),
    backgroundImage: {
        url: "".concat(SunsetImage, "?opto&auto=webp"),
        altText: "Woman watching sunset"
    },
    imageClassName: "hero-image",
    shouldDisplaySilhouette: true
};
var protocolRegex = /(^\w+:|^)/g;
var queryRegex = /\?(.*)/g;
function trimContentfulAssetUrl(url) {
    return url.replace(protocolRegex, "").replace(queryRegex, "");
}
function HomeDesktop() {
    var ref;
    var heroImage = (0,useContentfulVariation/* default */.Z)("heroImage");
    var heroImageContentfulAsset = heroImage === null || heroImage === void 0 ? void 0 : heroImage.asset;
    var _title;
    var heroProps = (heroImageContentfulAsset === null || heroImageContentfulAsset === void 0 ? void 0 : (ref = heroImageContentfulAsset.file) === null || ref === void 0 ? void 0 : ref.url) ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultHeroProps), {
        backgroundImage: {
            url: "https:".concat(trimContentfulAssetUrl(heroImageContentfulAsset.file.url), "?fm=jpg&q=80"),
            altText: (_title = heroImageContentfulAsset.title) !== null && _title !== void 0 ? _title : ""
        }
    }) : (0,_object_spread/* default */.Z)({}, defaultHeroProps);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: heroProps.backgroundImage.url
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                style: {
                    "overflow-x": "hidden"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        height: "100%",
                        "data-testid": "hero-outer-box",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroModule/* default */.Z, (0,_object_spread/* default */.Z)({}, heroProps))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeContent, {})
                ]
            })
        ]
    });
}


/***/ }),

/***/ 55173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ExpressDealModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var pcln_design_system__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92591);
/* harmony import */ var pcln_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97679);
/* harmony import */ var _components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29293);
/* harmony import */ var _hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77185);
/* harmony import */ var _constants_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66487);
/* harmony import */ var _constants_content__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66410);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69722);
/* harmony import */ var _SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84822);
/* harmony import */ var _SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49515);













function ExpressDealModal(param) {
    var isModalOpen = param.isModalOpen, _gaCategory = param.gaCategory, gaCategory = _gaCategory === void 0 ? _constants_analytics__WEBPACK_IMPORTED_MODULE_4__/* .ANALYTICS_CATEGORY_HOTELS */ .T : _gaCategory, _qsKey = param.qsKey, qsKey = _qsKey === void 0 ? "modal" : _qsKey, _qsValue = param.qsValue, qsValue = _qsValue === void 0 ? "express-deals" : _qsValue;
    var closeModal = (0,_hooks_useExpressDealModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(qsKey, qsValue).closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        enableOverflow: true,
        ariaLabel: "Express Deals Search Modal",
        isOpen: isModalOpen,
        onClose: closeModal,
        timeout: 50,
        width: [
            1,
            750
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
            p: [
                3,
                0
            ],
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    px: [
                        0,
                        3
                    ],
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            fontSize: [
                                3,
                                null,
                                null,
                                5
                            ],
                            lineHeight: "display",
                            tag: "h1",
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.hotel.expressDeals.headline */ .ZP.homepage.hotel.expressDeals.headline
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StyledHeading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            fontSize: [
                                1,
                                null,
                                null,
                                4
                            ],
                            mb: 3,
                            lineHeight: "display",
                            tag: "h2",
                            text: _constants_content__WEBPACK_IMPORTED_MODULE_5__/* ["default"].homepage.hotel.expressDeals.subHeadline */ .ZP.homepage.hotel.expressDeals.subHeadline
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pcln_design_system__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    pb: 4,
                    px: [
                        0,
                        3
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SearchForm_Form__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        onSubmit: function(values) {
                            return (0,_SearchForm_utils__WEBPACK_IMPORTED_MODULE_7__/* .handleSubmitForExpressDeals */ .C5)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, values), {
                                gaCategory: gaCategory
                            }));
                        },
                        promoDeal: _constants__WEBPACK_IMPORTED_MODULE_6__/* .PromoDeal.EXPRESS_DEAL */ .cS.EXPRESS_DEAL
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 8862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73779);



var PromoBanners = function(param) {
    var merchModules = param.merchModules;
    return merchModules.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: merchModules.map(function(merchModule) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    content: merchModule
                })
            }, merchModule === null || merchModule === void 0 ? void 0 : merchModule.internalName);
        })
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (PromoBanners);


/***/ }),

/***/ 57969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ WhyPricelineBanner_WhyPricelineBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/BlockLink/BlockLink.js
var BlockLink = __webpack_require__(21477);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Cars.js
var Cars = __webpack_require__(70895);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Discount.js
var Discount = __webpack_require__(72027);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Email.js
var Email = __webpack_require__(40124);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Help.js
var Help = __webpack_require__(45932);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Phone.js
var Phone = __webpack_require__(11761);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/Verified.js
var Verified = __webpack_require__(26310);
;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/ReasonsToBelieveTile.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-b1bde579-0"
})(_templateObject());
var ConditionalBlockLink = function(param) {
    var children = param.children, href = param.href;
    return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlockLink/* default */.Z, {
        href: href,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var ICONS = {
    Cars: Cars/* default */.Z,
    Discount: Discount/* default */.Z,
    Email: Email/* default */.Z,
    Help: Help/* default */.Z,
    Phone: Phone/* default */.Z,
    Verified: Verified/* default */.Z
};
var ReasonsToBelieveTile = function(param) {
    var headingFontColor = param.headingFontColor, _href = param.href, href = _href === void 0 ? "" : _href, iconColor = param.iconColor, subtextFontColor = param.subtextFontColor, tileContent = param.tileContent, tileCount = param.tileCount;
    var heading = tileContent.heading, iconName = tileContent.iconName, subtext = tileContent.subtext;
    var Icon = ICONS[iconName] || Box/* default */.Z;
    var paddingX = tileCount < 4 ? 4 : 2;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
        width: 1 / tileCount,
        px: paddingX,
        py: 3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConditionalBlockLink, {
            href: href,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                    color: iconColor,
                    size: 28
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    caps: true,
                    color: headingFontColor,
                    textAlign: "center",
                    textStyle: "heading5",
                    py: 2,
                    children: heading
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    color: subtextFontColor,
                    textAlign: "center",
                    textStyle: "paragraph",
                    children: subtext
                })
            ]
        })
    });
};
/* harmony default export */ var WhyPricelineBanner_ReasonsToBelieveTile = (ReasonsToBelieveTile);

;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/WhyPricelineBanner.tsx

function WhyPricelineBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 1280px;\n"
    ]);
    WhyPricelineBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-7e5f1de1-0"
})(WhyPricelineBanner_templateObject());
var WhyPricelineBanner = function(param) {
    var _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "background.lightest" : _backgroundColor, content = param.content, _headingFontColor = param.headingFontColor, headingFontColor = _headingFontColor === void 0 ? "text.base" : _headingFontColor, _iconColor = param.iconColor, iconColor = _iconColor === void 0 ? "primary" : _iconColor, _subtextFontColor = param.subtextFontColor, subtextFontColor = _subtextFontColor === void 0 ? "text.light" : _subtextFontColor;
    var tileCount = content.length;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        color: backgroundColor,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFlex, {
            color: backgroundColor,
            justifyContent: "space-around",
            mx: "auto",
            p: 3,
            tileCount: tileCount,
            children: content && content.map(function(tileContent) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyPricelineBanner_ReasonsToBelieveTile, {
                    href: tileContent.href,
                    headingFontColor: headingFontColor,
                    iconColor: iconColor,
                    subtextFontColor: subtextFontColor,
                    tileContent: tileContent,
                    tileCount: tileCount
                }, tileContent.iconName);
            })
        })
    });
};
/* harmony default export */ var WhyPricelineBanner_WhyPricelineBanner = (WhyPricelineBanner);

;// CONCATENATED MODULE: ./src/components/WhyPricelineBanner/index.ts



/***/ }),

/***/ 94228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ REASONS_HOTELS_LP; },
/* harmony export */   "Y": function() { return /* binding */ REASONS_HOME; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var FLEXIBLE_BOOKING_TILE = {
    iconName: "Verified",
    heading: "Flexible Bookings",
    subtext: "Plans change. That’s why we offer free cancellation on most hotels & rental cars."
};
var DISCOUNT_TILE = {
    iconName: "Discount",
    heading: "Incredible Deals",
    subtext: "Check out with confidence. Priceline members always get our best price.",
    href: "https://help.priceline.com/what-is-best-price-guarantee-Sys6cJ86u"
};
var DISCOUNT_HOTELS_LP_TILE = {
    iconName: "Discount",
    heading: "Book With Confidence",
    subtext: "Priceline members always get our best price.",
    href: "https://help.priceline.com/what-is-best-price-guarantee-Sys6cJ86u"
};
var RC_TILE = {
    iconName: "Cars",
    heading: "No Flight? No Problem",
    subtext: "Bundle hotel & rental car deals to build your perfect getaway. No airtime required."
};
var PHONE_HOTELS_LP_VARIANT_TILE = {
    iconName: "Phone",
    heading: "Unlock Special Discounts",
    subtext: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            "1 in 4 people save 20% or more over the phone. Call Now.",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
            "(833) 378-0470"
        ]
    })
};
var HELP_TILE = {
    iconName: "Help",
    heading: "Help 24/7",
    subtext: "We’re always here for you – reach us 24 hours a day, 7 days a week.",
    href: "https://help.priceline.com"
};
var REASONS_HOME = [
    FLEXIBLE_BOOKING_TILE,
    DISCOUNT_TILE,
    RC_TILE,
    HELP_TILE
];
var REASONS_HOTELS_LP = [
    FLEXIBLE_BOOKING_TILE,
    DISCOUNT_HOTELS_LP_TILE,
    PHONE_HOTELS_LP_VARIANT_TILE,
    HELP_TILE
];


/***/ })

}]);